"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fakeMtCompletionQueue = fakeMtCompletionQueue;
exports.fakeMtaVerificationQueue = fakeMtaVerificationQueue;
exports.fakeMtaCompletionQueue = fakeMtaCompletionQueue;
exports.fakeServerUser = fakeServerUser;
exports.fakeBox = fakeBox;
exports.fakeWorker = fakeWorker;
exports.fakeWorkerDeletionRequest = fakeWorkerDeletionRequest;
exports.fakeWorkerMonitoring = fakeWorkerMonitoring;
exports.fakeProjectGroup = fakeProjectGroup;
exports.fakeProject = fakeProject;
exports.fakeUserProjectAcl = fakeUserProjectAcl;
exports.fakeAvatar = fakeAvatar;
exports.fakeAvatarGenBulk = fakeAvatarGenBulk;
exports.fakeOtp = fakeOtp;
exports.fakeKaryaFile = fakeKaryaFile;
exports.fakeDataset = fakeDataset;
exports.fakeDatapoint = fakeDatapoint;
exports.fakeDatasetOp = fakeDatasetOp;
exports.fakeDatasetSubscription = fakeDatasetSubscription;
exports.fakeTask = fakeTask;
exports.fakeMicrotaskGroup = fakeMicrotaskGroup;
exports.fakeMicrotask = fakeMicrotask;
exports.fakeTaskOp = fakeTaskOp;
exports.fakeTaskAssignment = fakeTaskAssignment;
exports.fakeTaskSurvey = fakeTaskSurvey;
exports.fakeMicrotaskGroupAssignment = fakeMicrotaskGroupAssignment;
exports.fakeMicrotaskAssignment = fakeMicrotaskAssignment;
exports.fakeMicrotaskAssignmentBatch = fakeMicrotaskAssignmentBatch;
exports.fakeMicrotaskAssignmentBatchMember = fakeMicrotaskAssignmentBatchMember;
exports.fakeScriptOp = fakeScriptOp;
exports.fakeReferral = fakeReferral;
exports.fakeAdditionalPayment = fakeAdditionalPayment;
exports.fakeDeviceRestriction = fakeDeviceRestriction;
exports.fakeFundAccountRestriction = fakeFundAccountRestriction;
exports.fakeTicket = fakeTicket;
exports.fakeClients = fakeClients;
exports.fakeReports = fakeReports;
exports.fakeClientReports = fakeClientReports;
exports.fakeConferencer = fakeConferencer;
exports.fakeFundAccount = fakeFundAccount;
exports.fakeTransaction = fakeTransaction;
exports.fakeBulkTransaction = fakeBulkTransaction;
exports.fakePaymentTransactionJobs = fakePaymentTransactionJobs;
exports.fakeSevaUser = fakeSevaUser;
exports.fakeSevaUserTickets = fakeSevaUserTickets;
exports.fakeEligibleUsersQuery = fakeEligibleUsersQuery;
exports.fakeForm = fakeForm;
exports.fakeFormAssignment = fakeFormAssignment;
exports.fakeFormTrigger = fakeFormTrigger;
exports.fakeNotification = fakeNotification;
exports.fakeLearnTask = fakeLearnTask;
exports.fakeLearnWorkerStats = fakeLearnWorkerStats;
exports.fakeOrgConfig = fakeOrgConfig;
exports.fakeExternalServiceProviderConfig = fakeExternalServiceProviderConfig;
exports.fakeOrgServiceProviderMapping = fakeOrgServiceProviderMapping;
exports.fakeOrgPaymentConfig = fakeOrgPaymentConfig;
exports.fakePaymentProviderAccountConfigs = fakePaymentProviderAccountConfigs;
exports.fakeBulkTransactionTask = fakeBulkTransactionTask;
exports.fakeWorkerTaskPayment = fakeWorkerTaskPayment;
exports.fakeWorkerKyc = fakeWorkerKyc;
exports.fakeWorkerTdsEligibility = fakeWorkerTdsEligibility;
exports.fakeWorkerProjectFyEarnings = fakeWorkerProjectFyEarnings;
exports.fakeWorkerProjectFyTransfers = fakeWorkerProjectFyTransfers;
const faker_1 = require("@faker-js/faker");
// Random data generators for each table
function fakeMtCompletionQueue() {
    return {
        mt_id: faker_1.faker.number.bigInt().toString(),
        created_at: faker_1.faker.date.recent({ days: 30 }).toISOString(),
        last_updated_at: faker_1.faker.date.recent({ days: 30 }).toISOString(),
    };
}
function fakeMtaVerificationQueue() {
    return {
        mta_id: faker_1.faker.number.bigInt().toString(),
        created_at: faker_1.faker.date.recent({ days: 30 }).toISOString(),
        last_updated_at: faker_1.faker.date.recent({ days: 30 }).toISOString(),
    };
}
function fakeMtaCompletionQueue() {
    return {
        mta_id: faker_1.faker.number.bigInt().toString(),
        created_at: faker_1.faker.date.recent({ days: 30 }).toISOString(),
        last_updated_at: faker_1.faker.date.recent({ days: 30 }).toISOString(),
    };
}
function fakeServerUser() {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    return {
        id: faker_1.faker.number.bigInt().toString(),
        access_code: faker_1.faker.string.numeric(8),
        registered: faker_1.faker.datatype.boolean(),
        reg_mechanism: (_a = faker_1.faker.helpers.maybe(() => faker_1.faker.helpers.arrayElement(['self-gen-key', 'google-id-token', 'phone-otp']))) !== null && _a !== void 0 ? _a : null,
        phone_number: (_b = faker_1.faker.helpers.maybe(() => faker_1.faker.phone.number({ style: 'international' }))) !== null && _b !== void 0 ? _b : null,
        otp: (_c = faker_1.faker.helpers.maybe(() => faker_1.faker.lorem.words({ min: 2, max: 10 }).slice(0, 8))) !== null && _c !== void 0 ? _c : null,
        otp_generated_at: (_d = faker_1.faker.helpers.maybe(() => ({
            otp_generated_at: faker_1.faker.helpers.arrayElements(faker_1.faker.lorem.words().split(' '), { min: 1, max: 5 }),
        }))) !== null && _d !== void 0 ? _d : null,
        auth_id: (_e = faker_1.faker.helpers.maybe(() => faker_1.faker.string.uuid().replace(/-/g, '').slice(0, 64))) !== null && _e !== void 0 ? _e : null,
        id_token: (_f = faker_1.faker.helpers.maybe(() => faker_1.faker.lorem.paragraph())) !== null && _f !== void 0 ? _f : null,
        role: faker_1.faker.helpers.arrayElement(['SUPER_ADMIN', 'ADMIN', 'COORDINATOR', 'EXTERNAL_COORDINATOR', 'INACTIVE']),
        role_mappings: (_g = faker_1.faker.helpers.maybe(() => ({
            role_mappings: faker_1.faker.helpers.arrayElements(faker_1.faker.lorem.words().split(' '), { min: 1, max: 5 }),
        }))) !== null && _g !== void 0 ? _g : null,
        full_name: (_h = faker_1.faker.helpers.maybe(() => faker_1.faker.lorem.words({ min: 2, max: 10 }).slice(0, 64))) !== null && _h !== void 0 ? _h : null,
        email: (_j = faker_1.faker.helpers.maybe(() => faker_1.faker.internet.email())) !== null && _j !== void 0 ? _j : null,
        org_id: (_k = faker_1.faker.helpers.maybe(() => faker_1.faker.number.bigInt().toString())) !== null && _k !== void 0 ? _k : null,
        extras: (_l = faker_1.faker.helpers.maybe(() => Object.fromEntries(faker_1.faker.helpers
            .arrayElements(faker_1.faker.lorem.words().split(' '), { min: 1, max: 5 })
            .map((word) => [word, faker_1.faker.string.alpha()])))) !== null && _l !== void 0 ? _l : null,
        created_at: faker_1.faker.date.recent({ days: 30 }).toISOString(),
        last_updated_at: faker_1.faker.date.recent({ days: 30 }).toISOString(),
    };
}
function fakeBox() {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    return {
        id: faker_1.faker.number.bigInt().toString(),
        access_code: faker_1.faker.string.numeric(8),
        registered: faker_1.faker.datatype.boolean(),
        reg_mechanism: (_a = faker_1.faker.helpers.maybe(() => faker_1.faker.helpers.arrayElement(['self-gen-key', 'google-id-token', 'phone-otp']))) !== null && _a !== void 0 ? _a : null,
        key: (_b = faker_1.faker.helpers.maybe(() => faker_1.faker.lorem.words({ min: 2, max: 10 }).slice(0, 64))) !== null && _b !== void 0 ? _b : null,
        physical: faker_1.faker.datatype.boolean(),
        name: (_c = faker_1.faker.helpers.maybe(() => faker_1.faker.lorem.words({ min: 2, max: 10 }).slice(0, 64))) !== null && _c !== void 0 ? _c : null,
        location: (_d = faker_1.faker.helpers.maybe(() => faker_1.faker.lorem.words({ min: 2, max: 10 }).slice(0, 64))) !== null && _d !== void 0 ? _d : null,
        gps: (_e = faker_1.faker.helpers.maybe(() => faker_1.faker.lorem.words({ min: 2, max: 10 }).slice(0, 64))) !== null && _e !== void 0 ? _e : null,
        url: (_f = faker_1.faker.helpers.maybe(() => faker_1.faker.internet.url().slice(0, 256))) !== null && _f !== void 0 ? _f : null,
        auth_id: (_g = faker_1.faker.helpers.maybe(() => faker_1.faker.string.uuid().replace(/-/g, '').slice(0, 64))) !== null && _g !== void 0 ? _g : null,
        id_token: (_h = faker_1.faker.helpers.maybe(() => faker_1.faker.lorem.paragraph())) !== null && _h !== void 0 ? _h : null,
        last_received_from_server_at: faker_1.faker.date.recent({ days: 30 }).toISOString(),
        last_sent_to_server_at: faker_1.faker.date.recent({ days: 30 }).toISOString(),
        extras: (_j = faker_1.faker.helpers.maybe(() => Object.fromEntries(faker_1.faker.helpers
            .arrayElements(faker_1.faker.lorem.words().split(' '), { min: 1, max: 5 })
            .map((word) => [word, faker_1.faker.string.alpha()])))) !== null && _j !== void 0 ? _j : null,
        created_at: faker_1.faker.date.recent({ days: 30 }).toISOString(),
        last_updated_at: faker_1.faker.date.recent({ days: 30 }).toISOString(),
    };
}
function fakeWorker() {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    return {
        id: faker_1.faker.number.bigInt().toString(),
        phone_number: faker_1.faker.phone.number({ style: 'international' }),
        category: faker_1.faker.helpers.arrayElement(['WORKER', 'INTERNAL']),
        full_name: (_a = faker_1.faker.helpers.maybe(() => faker_1.faker.lorem.words({ min: 2, max: 10 }).slice(0, 64))) !== null && _a !== void 0 ? _a : null,
        gender: (_b = faker_1.faker.helpers.maybe(() => faker_1.faker.lorem.words({ min: 2, max: 10 }).slice(0, 15))) !== null && _b !== void 0 ? _b : null,
        pincode: (_c = faker_1.faker.helpers.maybe(() => faker_1.faker.lorem.words({ min: 2, max: 10 }).slice(0, 16))) !== null && _c !== void 0 ? _c : null,
        yob: (_d = faker_1.faker.helpers.maybe(() => faker_1.faker.number.int())) !== null && _d !== void 0 ? _d : null,
        profile: Object.fromEntries(faker_1.faker.helpers
            .arrayElements(faker_1.faker.lorem.words().split(' '), { min: 1, max: 5 })
            .map((word) => [word, faker_1.faker.string.alpha()])),
        profile_updated_at: (_e = faker_1.faker.helpers.maybe(() => faker_1.faker.date.recent({ days: 30 }).toISOString())) !== null && _e !== void 0 ? _e : null,
        id_token: (_f = faker_1.faker.helpers.maybe(() => faker_1.faker.lorem.paragraph())) !== null && _f !== void 0 ? _f : null,
        tags: { tags: faker_1.faker.helpers.arrayElements(faker_1.faker.lorem.words().split(' '), { min: 1, max: 5 }) },
        summary: Object.fromEntries(faker_1.faker.helpers
            .arrayElements(faker_1.faker.lorem.words().split(' '), { min: 1, max: 5 })
            .map((word) => [word, faker_1.faker.string.alpha()])),
        fcm_token: (_g = faker_1.faker.helpers.maybe(() => faker_1.faker.lorem.words({ min: 2, max: 10 }).slice(0, 256))) !== null && _g !== void 0 ? _g : null,
        pan_verified_at: (_h = faker_1.faker.helpers.maybe(() => faker_1.faker.date.recent({ days: 30 }).toISOString())) !== null && _h !== void 0 ? _h : null,
        extras: (_j = faker_1.faker.helpers.maybe(() => Object.fromEntries(faker_1.faker.helpers
            .arrayElements(faker_1.faker.lorem.words().split(' '), { min: 1, max: 5 })
            .map((word) => [word, faker_1.faker.string.alpha()])))) !== null && _j !== void 0 ? _j : null,
        preferences: (_k = faker_1.faker.helpers.maybe(() => Object.fromEntries(faker_1.faker.helpers
            .arrayElements(faker_1.faker.lorem.words().split(' '), { min: 1, max: 5 })
            .map((word) => [word, faker_1.faker.string.alpha()])))) !== null && _k !== void 0 ? _k : null,
        disabled: (_l = faker_1.faker.helpers.maybe(() => faker_1.faker.datatype.boolean())) !== null && _l !== void 0 ? _l : null,
        disabled_reason: (_m = faker_1.faker.helpers.maybe(() => faker_1.faker.lorem.paragraph())) !== null && _m !== void 0 ? _m : null,
        kyc_retry_count: faker_1.faker.number.int(),
        org_id: faker_1.faker.number.bigInt().toString(),
        created_at: faker_1.faker.date.recent({ days: 30 }).toISOString(),
        last_updated_at: faker_1.faker.date.recent({ days: 30 }).toISOString(),
    };
}
function fakeWorkerDeletionRequest() {
    var _a, _b, _c;
    return {
        id: faker_1.faker.number.bigInt().toString(),
        worker_id: faker_1.faker.number.bigInt().toString(),
        requested_at: faker_1.faker.date.recent({ days: 30 }).toISOString(),
        status: faker_1.faker.helpers.arrayElement(['PENDING', 'CANCELLED', 'DELETED']),
        completed_at: (_a = faker_1.faker.helpers.maybe(() => faker_1.faker.date.recent({ days: 30 }).toISOString())) !== null && _a !== void 0 ? _a : null,
        reason: (_b = faker_1.faker.helpers.maybe(() => faker_1.faker.lorem.paragraph())) !== null && _b !== void 0 ? _b : null,
        reason_details: (_c = faker_1.faker.helpers.maybe(() => faker_1.faker.lorem.paragraph())) !== null && _c !== void 0 ? _c : null,
        created_at: faker_1.faker.date.recent({ days: 30 }).toISOString(),
        last_updated_at: faker_1.faker.date.recent({ days: 30 }).toISOString(),
    };
}
function fakeWorkerMonitoring() {
    var _a, _b, _c;
    return {
        id: faker_1.faker.number.bigInt().toString(),
        worker_id: (_a = faker_1.faker.helpers.maybe(() => faker_1.faker.number.bigInt().toString())) !== null && _a !== void 0 ? _a : null,
        project_id: (_b = faker_1.faker.helpers.maybe(() => faker_1.faker.number.bigInt().toString())) !== null && _b !== void 0 ? _b : null,
        data: Object.fromEntries(faker_1.faker.helpers
            .arrayElements(faker_1.faker.lorem.words().split(' '), { min: 1, max: 5 })
            .map((word) => [word, faker_1.faker.string.alpha()])),
        day: faker_1.faker.number.int(),
        extras: (_c = faker_1.faker.helpers.maybe(() => Object.fromEntries(faker_1.faker.helpers
            .arrayElements(faker_1.faker.lorem.words().split(' '), { min: 1, max: 5 })
            .map((word) => [word, faker_1.faker.string.alpha()])))) !== null && _c !== void 0 ? _c : null,
        created_at: faker_1.faker.date.recent({ days: 30 }).toISOString(),
        last_updated_at: faker_1.faker.date.recent({ days: 30 }).toISOString(),
    };
}
function fakeProjectGroup() {
    var _a, _b;
    return {
        id: faker_1.faker.number.bigInt().toString(),
        code_name: faker_1.faker.lorem.words({ min: 2, max: 10 }).slice(0, 128),
        name: faker_1.faker.lorem.words({ min: 2, max: 10 }).slice(0, 128),
        description: (_a = faker_1.faker.helpers.maybe(() => faker_1.faker.lorem.paragraph())) !== null && _a !== void 0 ? _a : null,
        status: faker_1.faker.helpers.arrayElement(['ACTIVE', 'INACTIVE']),
        extras: (_b = faker_1.faker.helpers.maybe(() => Object.fromEntries(faker_1.faker.helpers
            .arrayElements(faker_1.faker.lorem.words().split(' '), { min: 1, max: 5 })
            .map((word) => [word, faker_1.faker.string.alpha()])))) !== null && _b !== void 0 ? _b : null,
        created_at: faker_1.faker.date.recent({ days: 30 }).toISOString(),
        last_updated_at: faker_1.faker.date.recent({ days: 30 }).toISOString(),
    };
}
function fakeProject() {
    var _a, _b, _c, _d, _e, _f;
    return {
        id: faker_1.faker.number.bigInt().toString(),
        code_name: (_a = faker_1.faker.helpers.maybe(() => faker_1.faker.lorem.words({ min: 2, max: 10 }).slice(0, 128))) !== null && _a !== void 0 ? _a : null,
        name: faker_1.faker.lorem.words({ min: 2, max: 10 }).slice(0, 128),
        description: (_b = faker_1.faker.helpers.maybe(() => faker_1.faker.lorem.paragraph())) !== null && _b !== void 0 ? _b : null,
        props: (_c = faker_1.faker.helpers.maybe(() => Object.fromEntries(faker_1.faker.helpers
            .arrayElements(faker_1.faker.lorem.words().split(' '), { min: 1, max: 5 })
            .map((word) => [word, faker_1.faker.string.alpha()])))) !== null && _c !== void 0 ? _c : null,
        migration_status: faker_1.faker.helpers.arrayElement(['NOT_MIGRATED', 'MIGRATING', 'MIGRATED', 'FAILED']),
        status: faker_1.faker.helpers.arrayElement(['ACTIVE', 'INACTIVE', 'COMPLETED', 'ARCHIVED']),
        payments_enabled: (_d = faker_1.faker.helpers.maybe(() => faker_1.faker.datatype.boolean())) !== null && _d !== void 0 ? _d : null,
        payment_mode: faker_1.faker.helpers.arrayElement(['TASK', 'PROJECT']),
        version: faker_1.faker.helpers.arrayElement(['V1', 'V2']),
        project_group_id: (_e = faker_1.faker.helpers.maybe(() => faker_1.faker.number.bigInt().toString())) !== null && _e !== void 0 ? _e : null,
        org_id: faker_1.faker.number.bigInt().toString(),
        extras: (_f = faker_1.faker.helpers.maybe(() => Object.fromEntries(faker_1.faker.helpers
            .arrayElements(faker_1.faker.lorem.words().split(' '), { min: 1, max: 5 })
            .map((word) => [word, faker_1.faker.string.alpha()])))) !== null && _f !== void 0 ? _f : null,
        created_at: faker_1.faker.date.recent({ days: 30 }).toISOString(),
        last_updated_at: faker_1.faker.date.recent({ days: 30 }).toISOString(),
    };
}
function fakeUserProjectAcl() {
    var _a;
    return {
        id: faker_1.faker.number.bigInt().toString(),
        user_id: faker_1.faker.number.bigInt().toString(),
        project_id: faker_1.faker.number.bigInt().toString(),
        role: faker_1.faker.helpers.arrayElement([
            'PROJECT_MANAGER',
            'PROJECT_COORDINATOR',
            'FINANCE_MANAGER',
            'TECH_SUPPORT',
            'EXTERNAL_COORDINATOR',
        ]),
        extras: (_a = faker_1.faker.helpers.maybe(() => Object.fromEntries(faker_1.faker.helpers
            .arrayElements(faker_1.faker.lorem.words().split(' '), { min: 1, max: 5 })
            .map((word) => [word, faker_1.faker.string.alpha()])))) !== null && _a !== void 0 ? _a : null,
        created_at: faker_1.faker.date.recent({ days: 30 }).toISOString(),
        last_updated_at: faker_1.faker.date.recent({ days: 30 }).toISOString(),
    };
}
function fakeAvatar() {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    return {
        id: faker_1.faker.number.bigInt().toString(),
        box_id: faker_1.faker.number.bigInt().toString(),
        local_id: faker_1.faker.number.bigInt().toString(),
        project_id: faker_1.faker.number.bigInt().toString(),
        bulk_id: (_a = faker_1.faker.helpers.maybe(() => faker_1.faker.number.bigInt().toString())) !== null && _a !== void 0 ? _a : null,
        access_code: faker_1.faker.string.numeric(8),
        config: (_b = faker_1.faker.helpers.maybe(() => Object.fromEntries(faker_1.faker.helpers
            .arrayElements(faker_1.faker.lorem.words().split(' '), { min: 1, max: 5 })
            .map((word) => [word, faker_1.faker.string.alpha()])))) !== null && _b !== void 0 ? _b : null,
        task_id: (_c = faker_1.faker.helpers.maybe(() => faker_1.faker.number.bigInt().toString())) !== null && _c !== void 0 ? _c : null,
        test_passed: (_d = faker_1.faker.helpers.maybe(() => faker_1.faker.datatype.boolean())) !== null && _d !== void 0 ? _d : null,
        tags: { tags: faker_1.faker.helpers.arrayElements(faker_1.faker.lorem.words().split(' '), { min: 1, max: 5 }) },
        tags_updated_at: faker_1.faker.date.recent({ days: 30 }).toISOString(),
        is_disabled: faker_1.faker.datatype.boolean(),
        is_payments_disabled: faker_1.faker.datatype.boolean(),
        sent_to_server_at: faker_1.faker.date.recent({ days: 30 }).toISOString(),
        is_linked: faker_1.faker.datatype.boolean(),
        linked_at: (_e = faker_1.faker.helpers.maybe(() => faker_1.faker.date.recent({ days: 30 }).toISOString())) !== null && _e !== void 0 ? _e : null,
        worker_id: (_f = faker_1.faker.helpers.maybe(() => faker_1.faker.number.bigInt().toString())) !== null && _f !== void 0 ? _f : null,
        test: faker_1.faker.datatype.boolean(),
        summary: Object.fromEntries(faker_1.faker.helpers
            .arrayElements(faker_1.faker.lorem.words().split(' '), { min: 1, max: 5 })
            .map((word) => [word, faker_1.faker.string.alpha()])),
        journey_state: faker_1.faker.helpers.arrayElement([
            'INTRO',
            'CONFIG',
            'TUTORIAL',
            'TEST_TASK',
            'TEST_TASK_VALIDATION',
            'TEST_TASK_FAILED_END',
            'MAIN_TASK',
            'SUCCESS_END',
            'REFUSED_END',
            'TASK_COMPLETED',
            'EXPIRED_END',
            'SURVEY',
        ]),
        logs: (_g = faker_1.faker.helpers.maybe(() => Object.fromEntries(faker_1.faker.helpers
            .arrayElements(faker_1.faker.lorem.words().split(' '), { min: 1, max: 5 })
            .map((word) => [word, faker_1.faker.string.alpha()])))) !== null && _g !== void 0 ? _g : null,
        linked_device_id: (_h = faker_1.faker.helpers.maybe(() => faker_1.faker.string.uuid().replace(/-/g, '').slice(0, 32))) !== null && _h !== void 0 ? _h : null,
        extras: (_j = faker_1.faker.helpers.maybe(() => Object.fromEntries(faker_1.faker.helpers
            .arrayElements(faker_1.faker.lorem.words().split(' '), { min: 1, max: 5 })
            .map((word) => [word, faker_1.faker.string.alpha()])))) !== null && _j !== void 0 ? _j : null,
        created_at: faker_1.faker.date.recent({ days: 30 }).toISOString(),
        last_updated_at: faker_1.faker.date.recent({ days: 30 }).toISOString(),
    };
}
function fakeAvatarGenBulk() {
    var _a, _b, _c;
    return {
        id: faker_1.faker.number.bigInt().toString(),
        project_id: faker_1.faker.number.bigInt().toString(),
        name: (_a = faker_1.faker.helpers.maybe(() => faker_1.faker.lorem.words({ min: 2, max: 10 }).slice(0, 256))) !== null && _a !== void 0 ? _a : null,
        box_id: faker_1.faker.number.bigInt().toString(),
        tags: { tags: faker_1.faker.helpers.arrayElements(faker_1.faker.lorem.words().split(' '), { min: 1, max: 5 }) },
        task_id: (_b = faker_1.faker.helpers.maybe(() => faker_1.faker.number.bigInt().toString())) !== null && _b !== void 0 ? _b : null,
        summary: Object.fromEntries(faker_1.faker.helpers
            .arrayElements(faker_1.faker.lorem.words().split(' '), { min: 1, max: 5 })
            .map((word) => [word, faker_1.faker.string.alpha()])),
        last_generated_at: faker_1.faker.date.recent({ days: 30 }).toISOString(),
        extras: (_c = faker_1.faker.helpers.maybe(() => Object.fromEntries(faker_1.faker.helpers
            .arrayElements(faker_1.faker.lorem.words().split(' '), { min: 1, max: 5 })
            .map((word) => [word, faker_1.faker.string.alpha()])))) !== null && _c !== void 0 ? _c : null,
        created_at: faker_1.faker.date.recent({ days: 30 }).toISOString(),
        last_updated_at: faker_1.faker.date.recent({ days: 30 }).toISOString(),
    };
}
function fakeOtp() {
    var _a, _b, _c, _d;
    return {
        id: faker_1.faker.number.bigInt().toString(),
        phone_number: faker_1.faker.phone.number({ style: 'international' }),
        otp_id: faker_1.faker.string.uuid().replace(/-/g, '').slice(0, 48),
        value: faker_1.faker.lorem.words({ min: 2, max: 10 }).slice(0, 12),
        status: faker_1.faker.lorem.words({ min: 2, max: 10 }).slice(0, 16),
        generated_at: faker_1.faker.date.recent({ days: 30 }).toISOString(),
        sent_at: (_a = faker_1.faker.helpers.maybe(() => faker_1.faker.date.recent({ days: 30 }).toISOString())) !== null && _a !== void 0 ? _a : null,
        resent_at: (_b = faker_1.faker.helpers.maybe(() => faker_1.faker.date.recent({ days: 30 }).toISOString())) !== null && _b !== void 0 ? _b : null,
        verified_at: (_c = faker_1.faker.helpers.maybe(() => faker_1.faker.date.recent({ days: 30 }).toISOString())) !== null && _c !== void 0 ? _c : null,
        extras: (_d = faker_1.faker.helpers.maybe(() => Object.fromEntries(faker_1.faker.helpers
            .arrayElements(faker_1.faker.lorem.words().split(' '), { min: 1, max: 5 })
            .map((word) => [word, faker_1.faker.string.alpha()])))) !== null && _d !== void 0 ? _d : null,
        created_at: faker_1.faker.date.recent({ days: 30 }).toISOString(),
        last_updated_at: faker_1.faker.date.recent({ days: 30 }).toISOString(),
    };
}
function fakeKaryaFile() {
    var _a, _b, _c, _d, _e, _f, _g;
    return {
        id: faker_1.faker.string.uuid().replace(/-/g, '').slice(0, 50),
        box_id: (_a = faker_1.faker.helpers.maybe(() => faker_1.faker.number.bigInt().toString())) !== null && _a !== void 0 ? _a : null,
        local_id: faker_1.faker.number.bigInt().toString(),
        project_id: faker_1.faker.number.bigInt().toString(),
        container_name: faker_1.faker.helpers.arrayElement([
            'language-assets',
            'datapoint',
            'report',
            'exports',
            'audioprompts',
            'conferencer',
            'worker-certificates',
            'worker-profile-picture',
            'worker-resume',
            'form-data',
            'org-consent',
        ]),
        name: faker_1.faker.lorem.words({ min: 2, max: 10 }).slice(0, 512),
        orig_name: (_b = faker_1.faker.helpers.maybe(() => faker_1.faker.lorem.words({ min: 2, max: 10 }).slice(0, 512))) !== null && _b !== void 0 ? _b : null,
        url: (_c = faker_1.faker.helpers.maybe(() => faker_1.faker.internet.url().slice(0, 1024))) !== null && _c !== void 0 ? _c : null,
        creator: faker_1.faker.helpers.arrayElement(['SERVER', 'BOX', 'WORKER', 'AUTO_TRANSFORM']),
        creator_id: faker_1.faker.number.bigInt().toString(),
        timestamp: (_d = faker_1.faker.helpers.maybe(() => faker_1.faker.date.recent({ days: 30 }).toISOString())) !== null && _d !== void 0 ? _d : null,
        algorithm: (_e = faker_1.faker.helpers.maybe(() => faker_1.faker.helpers.arrayElement(['MD5']))) !== null && _e !== void 0 ? _e : null,
        checksum: (_f = faker_1.faker.helpers.maybe(() => faker_1.faker.lorem.words({ min: 2, max: 10 }).slice(0, 64))) !== null && _f !== void 0 ? _f : null,
        in_box: faker_1.faker.datatype.boolean(),
        in_server: faker_1.faker.datatype.boolean(),
        extras: (_g = faker_1.faker.helpers.maybe(() => Object.fromEntries(faker_1.faker.helpers
            .arrayElements(faker_1.faker.lorem.words().split(' '), { min: 1, max: 5 })
            .map((word) => [word, faker_1.faker.string.alpha()])))) !== null && _g !== void 0 ? _g : null,
        created_at: faker_1.faker.date.recent({ days: 30 }).toISOString(),
        last_updated_at: faker_1.faker.date.recent({ days: 30 }).toISOString(),
    };
}
function fakeDataset() {
    var _a, _b;
    return {
        id: faker_1.faker.number.bigInt().toString(),
        project_id: faker_1.faker.number.bigInt().toString(),
        dtype: faker_1.faker.lorem.words({ min: 2, max: 10 }).slice(0, 32),
        name: faker_1.faker.lorem.words({ min: 2, max: 10 }).slice(0, 128),
        source: Object.fromEntries(faker_1.faker.helpers
            .arrayElements(faker_1.faker.lorem.words().split(' '), { min: 1, max: 5 })
            .map((word) => [word, faker_1.faker.string.alpha()])),
        props: Object.fromEntries(faker_1.faker.helpers
            .arrayElements(faker_1.faker.lorem.words().split(' '), { min: 1, max: 5 })
            .map((word) => [word, faker_1.faker.string.alpha()])),
        summary: Object.fromEntries(faker_1.faker.helpers
            .arrayElements(faker_1.faker.lorem.words().split(' '), { min: 1, max: 5 })
            .map((word) => [word, faker_1.faker.string.alpha()])),
        dataset_shape: (_a = faker_1.faker.helpers.maybe(() => Object.fromEntries(faker_1.faker.helpers
            .arrayElements(faker_1.faker.lorem.words().split(' '), { min: 1, max: 5 })
            .map((word) => [word, faker_1.faker.string.alpha()])))) !== null && _a !== void 0 ? _a : null,
        is_gold: faker_1.faker.datatype.boolean(),
        extras: (_b = faker_1.faker.helpers.maybe(() => Object.fromEntries(faker_1.faker.helpers
            .arrayElements(faker_1.faker.lorem.words().split(' '), { min: 1, max: 5 })
            .map((word) => [word, faker_1.faker.string.alpha()])))) !== null && _b !== void 0 ? _b : null,
        created_at: faker_1.faker.date.recent({ days: 30 }).toISOString(),
        last_updated_at: faker_1.faker.date.recent({ days: 30 }).toISOString(),
    };
}
function fakeDatapoint() {
    var _a, _b, _c, _d, _e;
    return {
        id: faker_1.faker.number.bigInt().toString(),
        old_id: (_a = faker_1.faker.helpers.maybe(() => faker_1.faker.string.uuid().replace(/-/g, '').slice(0, 50))) !== null && _a !== void 0 ? _a : null,
        project_id: faker_1.faker.number.bigInt().toString(),
        dataset_id: faker_1.faker.number.bigInt().toString(),
        data: Object.fromEntries(faker_1.faker.helpers
            .arrayElements(faker_1.faker.lorem.words().split(' '), { min: 1, max: 5 })
            .map((word) => [word, faker_1.faker.string.alpha()])),
        files: Object.fromEntries(faker_1.faker.helpers
            .arrayElements(faker_1.faker.lorem.words().split(' '), { min: 1, max: 5 })
            .map((word) => [word, faker_1.faker.string.alpha()])),
        file_id: (_b = faker_1.faker.helpers.maybe(() => faker_1.faker.string.uuid().replace(/-/g, '').slice(0, 50))) !== null && _b !== void 0 ? _b : null,
        props: Object.fromEntries(faker_1.faker.helpers
            .arrayElements(faker_1.faker.lorem.words().split(' '), { min: 1, max: 5 })
            .map((word) => [word, faker_1.faker.string.alpha()])),
        src_datapoint_id: (_c = faker_1.faker.helpers.maybe(() => faker_1.faker.number.bigInt().toString())) !== null && _c !== void 0 ? _c : null,
        generated_by_test_task: faker_1.faker.datatype.boolean(),
        generated_by_mta_id: (_d = faker_1.faker.helpers.maybe(() => faker_1.faker.number.bigInt().toString())) !== null && _d !== void 0 ? _d : null,
        status: faker_1.faker.helpers.arrayElement(['ACTIVE', 'MANUALLY_EXPIRED']),
        is_gold: faker_1.faker.datatype.boolean(),
        extras: (_e = faker_1.faker.helpers.maybe(() => Object.fromEntries(faker_1.faker.helpers
            .arrayElements(faker_1.faker.lorem.words().split(' '), { min: 1, max: 5 })
            .map((word) => [word, faker_1.faker.string.alpha()])))) !== null && _e !== void 0 ? _e : null,
        created_at: faker_1.faker.date.recent({ days: 30 }).toISOString(),
        last_updated_at: faker_1.faker.date.recent({ days: 30 }).toISOString(),
    };
}
function fakeDatasetOp() {
    var _a, _b, _c, _d, _e, _f;
    return {
        id: faker_1.faker.number.bigInt().toString(),
        project_id: faker_1.faker.number.bigInt().toString(),
        dataset_id: faker_1.faker.number.bigInt().toString(),
        op_type: faker_1.faker.helpers.arrayElement(['IMPORT', 'EXPORT', 'SUBSCRIBE']),
        ref_id: (_a = faker_1.faker.helpers.maybe(() => faker_1.faker.number.bigInt().toString())) !== null && _a !== void 0 ? _a : null,
        file_id: (_b = faker_1.faker.helpers.maybe(() => faker_1.faker.string.uuid().replace(/-/g, '').slice(0, 50))) !== null && _b !== void 0 ? _b : null,
        status: faker_1.faker.helpers.arrayElement(['CREATED', 'RUNNING', 'COMPLETED', 'FAILED']),
        started_at: (_c = faker_1.faker.helpers.maybe(() => faker_1.faker.date.recent({ days: 30 }).toISOString())) !== null && _c !== void 0 ? _c : null,
        completed_at: (_d = faker_1.faker.helpers.maybe(() => faker_1.faker.date.recent({ days: 30 }).toISOString())) !== null && _d !== void 0 ? _d : null,
        message: (_e = faker_1.faker.helpers.maybe(() => faker_1.faker.lorem.paragraph())) !== null && _e !== void 0 ? _e : null,
        extras: (_f = faker_1.faker.helpers.maybe(() => Object.fromEntries(faker_1.faker.helpers
            .arrayElements(faker_1.faker.lorem.words().split(' '), { min: 1, max: 5 })
            .map((word) => [word, faker_1.faker.string.alpha()])))) !== null && _f !== void 0 ? _f : null,
        created_at: faker_1.faker.date.recent({ days: 30 }).toISOString(),
        last_updated_at: faker_1.faker.date.recent({ days: 30 }).toISOString(),
    };
}
function fakeDatasetSubscription() {
    var _a, _b;
    return {
        id: faker_1.faker.number.bigInt().toString(),
        project_id: faker_1.faker.number.bigInt().toString(),
        dataset_id: faker_1.faker.number.bigInt().toString(),
        task_id: faker_1.faker.number.bigInt().toString(),
        filter: (_a = faker_1.faker.helpers.maybe(() => Object.fromEntries(faker_1.faker.helpers
            .arrayElements(faker_1.faker.lorem.words().split(' '), { min: 1, max: 5 })
            .map((word) => [word, faker_1.faker.string.alpha()])))) !== null && _a !== void 0 ? _a : null,
        status: faker_1.faker.lorem.words({ min: 2, max: 10 }).slice(0, 16),
        test: faker_1.faker.datatype.boolean(),
        extras: (_b = faker_1.faker.helpers.maybe(() => Object.fromEntries(faker_1.faker.helpers
            .arrayElements(faker_1.faker.lorem.words().split(' '), { min: 1, max: 5 })
            .map((word) => [word, faker_1.faker.string.alpha()])))) !== null && _b !== void 0 ? _b : null,
        created_at: faker_1.faker.date.recent({ days: 30 }).toISOString(),
        last_updated_at: faker_1.faker.date.recent({ days: 30 }).toISOString(),
    };
}
function fakeTask() {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
    return {
        id: faker_1.faker.number.bigInt().toString(),
        project_id: faker_1.faker.number.bigInt().toString(),
        work_provider_id: faker_1.faker.number.bigInt().toString(),
        scenario_name: faker_1.faker.lorem.words({ min: 2, max: 10 }).slice(0, 32),
        name: faker_1.faker.lorem.words({ min: 2, max: 10 }).slice(0, 128),
        description: faker_1.faker.lorem.paragraph(),
        display_name: faker_1.faker.lorem.words({ min: 2, max: 10 }).slice(0, 1024),
        policy: faker_1.faker.lorem.words({ min: 2, max: 10 }).slice(0, 16),
        params: Object.fromEntries(faker_1.faker.helpers
            .arrayElements(faker_1.faker.lorem.words().split(' '), { min: 1, max: 5 })
            .map((word) => [word, faker_1.faker.string.alpha()])),
        itags: { itags: faker_1.faker.helpers.arrayElements(faker_1.faker.lorem.words().split(' '), { min: 1, max: 5 }) },
        otags: { otags: faker_1.faker.helpers.arrayElements(faker_1.faker.lorem.words().split(' '), { min: 1, max: 5 }) },
        wgroup: (_a = faker_1.faker.helpers.maybe(() => faker_1.faker.lorem.words({ min: 2, max: 10 }).slice(0, 64))) !== null && _a !== void 0 ? _a : null,
        deadline: (_b = faker_1.faker.helpers.maybe(() => faker_1.faker.date.recent({ days: 30 }).toISOString())) !== null && _b !== void 0 ? _b : null,
        assignment_granularity: (_c = faker_1.faker.helpers.maybe(() => faker_1.faker.lorem.words({ min: 2, max: 10 }).slice(0, 16))) !== null && _c !== void 0 ? _c : null,
        group_assignment_order: (_d = faker_1.faker.helpers.maybe(() => faker_1.faker.lorem.words({ min: 2, max: 10 }).slice(0, 16))) !== null && _d !== void 0 ? _d : null,
        microtask_assignment_order: (_e = faker_1.faker.helpers.maybe(() => faker_1.faker.lorem.words({ min: 2, max: 10 }).slice(0, 16))) !== null && _e !== void 0 ? _e : null,
        assignment_batch_size: (_f = faker_1.faker.helpers.maybe(() => faker_1.faker.number.int())) !== null && _f !== void 0 ? _f : null,
        test_evaluation_policy: (_g = faker_1.faker.helpers.maybe(() => Object.fromEntries(faker_1.faker.helpers
            .arrayElements(faker_1.faker.lorem.words().split(' '), { min: 1, max: 5 })
            .map((word) => [word, faker_1.faker.string.alpha()])))) !== null && _g !== void 0 ? _g : null,
        completion_policy: Object.fromEntries(faker_1.faker.helpers
            .arrayElements(faker_1.faker.lorem.words().split(' '), { min: 1, max: 5 })
            .map((word) => [word, faker_1.faker.string.alpha()])),
        status: faker_1.faker.helpers.arrayElement(['DRAFT', 'PREVIEW', 'SUBMITTED', 'COMPLETED']),
        summary: (_h = faker_1.faker.helpers.maybe(() => Object.fromEntries(faker_1.faker.helpers
            .arrayElements(faker_1.faker.lorem.words().split(' '), { min: 1, max: 5 })
            .map((word) => [word, faker_1.faker.string.alpha()])))) !== null && _h !== void 0 ? _h : null,
        output_dataset_id: (_j = faker_1.faker.helpers.maybe(() => faker_1.faker.number.bigInt().toString())) !== null && _j !== void 0 ? _j : null,
        output_gen_granularity: (_k = faker_1.faker.helpers.maybe(() => faker_1.faker.helpers.arrayElement(['MICROTASK', 'ASSIGNMENT']))) !== null && _k !== void 0 ? _k : null,
        config_spec: (_l = faker_1.faker.helpers.maybe(() => Object.fromEntries(faker_1.faker.helpers
            .arrayElements(faker_1.faker.lorem.words().split(' '), { min: 1, max: 5 })
            .map((word) => [word, faker_1.faker.string.alpha()])))) !== null && _l !== void 0 ? _l : null,
        intro_spec: (_m = faker_1.faker.helpers.maybe(() => Object.fromEntries(faker_1.faker.helpers
            .arrayElements(faker_1.faker.lorem.words().split(' '), { min: 1, max: 5 })
            .map((word) => [word, faker_1.faker.string.alpha()])))) !== null && _m !== void 0 ? _m : null,
        tutorial_spec: (_o = faker_1.faker.helpers.maybe(() => Object.fromEntries(faker_1.faker.helpers
            .arrayElements(faker_1.faker.lorem.words().split(' '), { min: 1, max: 5 })
            .map((word) => [word, faker_1.faker.string.alpha()])))) !== null && _o !== void 0 ? _o : null,
        main_spec: Object.fromEntries(faker_1.faker.helpers
            .arrayElements(faker_1.faker.lorem.words().split(' '), { min: 1, max: 5 })
            .map((word) => [word, faker_1.faker.string.alpha()])),
        extras: (_p = faker_1.faker.helpers.maybe(() => Object.fromEntries(faker_1.faker.helpers
            .arrayElements(faker_1.faker.lorem.words().split(' '), { min: 1, max: 5 })
            .map((word) => [word, faker_1.faker.string.alpha()])))) !== null && _p !== void 0 ? _p : null,
        created_at: faker_1.faker.date.recent({ days: 30 }).toISOString(),
        last_updated_at: faker_1.faker.date.recent({ days: 30 }).toISOString(),
    };
}
function fakeMicrotaskGroup() {
    var _a;
    return {
        id: faker_1.faker.number.bigInt().toString(),
        task_id: faker_1.faker.number.bigInt().toString(),
        microtask_assignment_order: faker_1.faker.lorem.words({ min: 2, max: 10 }).slice(0, 16),
        status: faker_1.faker.helpers.arrayElement(['INCOMPLETE', 'COMPLETED', 'MANUALLY_EXPIRED']),
        extras: (_a = faker_1.faker.helpers.maybe(() => Object.fromEntries(faker_1.faker.helpers
            .arrayElements(faker_1.faker.lorem.words().split(' '), { min: 1, max: 5 })
            .map((word) => [word, faker_1.faker.string.alpha()])))) !== null && _a !== void 0 ? _a : null,
        created_at: faker_1.faker.date.recent({ days: 30 }).toISOString(),
        last_updated_at: faker_1.faker.date.recent({ days: 30 }).toISOString(),
    };
}
function fakeMicrotask() {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    return {
        id: faker_1.faker.number.bigInt().toString(),
        old_id: (_a = faker_1.faker.helpers.maybe(() => faker_1.faker.string.uuid().replace(/-/g, '').slice(0, 50))) !== null && _a !== void 0 ? _a : null,
        project_id: faker_1.faker.number.bigInt().toString(),
        task_id: faker_1.faker.number.bigInt().toString(),
        group_id: (_b = faker_1.faker.helpers.maybe(() => faker_1.faker.number.bigInt().toString())) !== null && _b !== void 0 ? _b : null,
        input: Object.fromEntries(faker_1.faker.helpers
            .arrayElements(faker_1.faker.lorem.words().split(' '), { min: 1, max: 5 })
            .map((word) => [word, faker_1.faker.string.alpha()])),
        input_file_id: (_c = faker_1.faker.helpers.maybe(() => faker_1.faker.string.uuid().replace(/-/g, '').slice(0, 50))) !== null && _c !== void 0 ? _c : null,
        input_dp_id: (_d = faker_1.faker.helpers.maybe(() => faker_1.faker.number.bigInt().toString())) !== null && _d !== void 0 ? _d : null,
        deadline: (_e = faker_1.faker.helpers.maybe(() => faker_1.faker.date.recent({ days: 30 }).toISOString())) !== null && _e !== void 0 ? _e : null,
        base_credits: faker_1.faker.number.int(),
        credits: faker_1.faker.number.int(),
        status: faker_1.faker.helpers.arrayElement(['INCOMPLETE', 'COMPLETED', 'MANUALLY_EXPIRED']),
        output: (_f = faker_1.faker.helpers.maybe(() => Object.fromEntries(faker_1.faker.helpers
            .arrayElements(faker_1.faker.lorem.words().split(' '), { min: 1, max: 5 })
            .map((word) => [word, faker_1.faker.string.alpha()])))) !== null && _f !== void 0 ? _f : null,
        output_dp_id: (_g = faker_1.faker.helpers.maybe(() => faker_1.faker.string.uuid().replace(/-/g, '').slice(0, 50))) !== null && _g !== void 0 ? _g : null,
        test: faker_1.faker.datatype.boolean(),
        is_gold: faker_1.faker.datatype.boolean(),
        extras: (_h = faker_1.faker.helpers.maybe(() => Object.fromEntries(faker_1.faker.helpers
            .arrayElements(faker_1.faker.lorem.words().split(' '), { min: 1, max: 5 })
            .map((word) => [word, faker_1.faker.string.alpha()])))) !== null && _h !== void 0 ? _h : null,
        created_at: faker_1.faker.date.recent({ days: 30 }).toISOString(),
        last_updated_at: faker_1.faker.date.recent({ days: 30 }).toISOString(),
    };
}
function fakeTaskOp() {
    var _a, _b, _c, _d;
    return {
        id: faker_1.faker.number.bigInt().toString(),
        project_id: faker_1.faker.number.bigInt().toString(),
        task_id: faker_1.faker.number.bigInt().toString(),
        op_type: faker_1.faker.helpers.arrayElement([
            'PROCESS_INPUT',
            'GENERATE_OUTPUT',
            'EXECUTE_FORWARD_TASK_LINK',
            'EXECUTE_BACKWARD_TASK_LINK',
            'HANDLE_ASSIGNMENT_COMPLETION',
            'HANDLE_VERIFIED_ASSIGNMENTS',
            'HANDLE_MICROTASK_COMPLETION',
            'EXECUTE_AUTO_TRANSFORM',
            'LINK_BY_PHONE',
            'LINK_BY_WORKER_ID',
        ]),
        file_id: (_a = faker_1.faker.helpers.maybe(() => faker_1.faker.string.uuid().replace(/-/g, '').slice(0, 50))) !== null && _a !== void 0 ? _a : null,
        status: faker_1.faker.helpers.arrayElement(['CREATED', 'RUNNING', 'COMPLETED', 'FAILED']),
        started_at: (_b = faker_1.faker.helpers.maybe(() => faker_1.faker.date.recent({ days: 30 }).toISOString())) !== null && _b !== void 0 ? _b : null,
        completed_at: (_c = faker_1.faker.helpers.maybe(() => faker_1.faker.date.recent({ days: 30 }).toISOString())) !== null && _c !== void 0 ? _c : null,
        messages: { messages: faker_1.faker.helpers.arrayElements(faker_1.faker.lorem.words().split(' '), { min: 1, max: 5 }) },
        extras: (_d = faker_1.faker.helpers.maybe(() => Object.fromEntries(faker_1.faker.helpers
            .arrayElements(faker_1.faker.lorem.words().split(' '), { min: 1, max: 5 })
            .map((word) => [word, faker_1.faker.string.alpha()])))) !== null && _d !== void 0 ? _d : null,
        created_at: faker_1.faker.date.recent({ days: 30 }).toISOString(),
        last_updated_at: faker_1.faker.date.recent({ days: 30 }).toISOString(),
    };
}
function fakeTaskAssignment() {
    var _a, _b;
    return {
        id: faker_1.faker.number.bigInt().toString(),
        project_id: faker_1.faker.number.bigInt().toString(),
        task_id: faker_1.faker.number.bigInt().toString(),
        box_id: faker_1.faker.number.bigInt().toString(),
        assignment_policy: Object.fromEntries(faker_1.faker.helpers
            .arrayElements(faker_1.faker.lorem.words().split(' '), { min: 1, max: 5 })
            .map((word) => [word, faker_1.faker.string.alpha()])),
        policy: faker_1.faker.lorem.words({ min: 2, max: 10 }).slice(0, 16),
        params: Object.fromEntries(faker_1.faker.helpers
            .arrayElements(faker_1.faker.lorem.words().split(' '), { min: 1, max: 5 })
            .map((word) => [word, faker_1.faker.string.alpha()])),
        deadline: (_a = faker_1.faker.helpers.maybe(() => faker_1.faker.date.recent({ days: 30 }).toISOString())) !== null && _a !== void 0 ? _a : null,
        status: faker_1.faker.helpers.arrayElement(['ASSIGNED', 'COMPLETED']),
        received_from_server_at: faker_1.faker.date.recent({ days: 30 }).toISOString(),
        extras: (_b = faker_1.faker.helpers.maybe(() => Object.fromEntries(faker_1.faker.helpers
            .arrayElements(faker_1.faker.lorem.words().split(' '), { min: 1, max: 5 })
            .map((word) => [word, faker_1.faker.string.alpha()])))) !== null && _b !== void 0 ? _b : null,
        created_at: faker_1.faker.date.recent({ days: 30 }).toISOString(),
        last_updated_at: faker_1.faker.date.recent({ days: 30 }).toISOString(),
    };
}
function fakeTaskSurvey() {
    var _a;
    return {
        id: faker_1.faker.number.bigInt().toString(),
        project_id: faker_1.faker.number.bigInt().toString(),
        task_id: faker_1.faker.number.bigInt().toString(),
        avatar_id: faker_1.faker.number.bigInt().toString(),
        worker_id: faker_1.faker.number.bigInt().toString(),
        survey: Object.fromEntries(faker_1.faker.helpers
            .arrayElements(faker_1.faker.lorem.words().split(' '), { min: 1, max: 5 })
            .map((word) => [word, faker_1.faker.string.alpha()])),
        extras: (_a = faker_1.faker.helpers.maybe(() => Object.fromEntries(faker_1.faker.helpers
            .arrayElements(faker_1.faker.lorem.words().split(' '), { min: 1, max: 5 })
            .map((word) => [word, faker_1.faker.string.alpha()])))) !== null && _a !== void 0 ? _a : null,
        created_at: faker_1.faker.date.recent({ days: 30 }).toISOString(),
        last_updated_at: faker_1.faker.date.recent({ days: 30 }).toISOString(),
    };
}
function fakeMicrotaskGroupAssignment() {
    var _a;
    return {
        id: faker_1.faker.number.bigInt().toString(),
        box_id: faker_1.faker.number.bigInt().toString(),
        local_id: faker_1.faker.number.bigInt().toString(),
        group_id: faker_1.faker.number.bigInt().toString(),
        task_id: faker_1.faker.number.bigInt().toString(),
        worker_id: faker_1.faker.number.bigInt().toString(),
        avatar_id: faker_1.faker.number.bigInt().toString(),
        test: faker_1.faker.datatype.boolean(),
        status: faker_1.faker.helpers.arrayElement([
            'ASSIGNED',
            'COMPLETED',
            'SUBMITTED',
            'SKIPPED',
            'EXPIRED',
            'VERIFIED',
            'IGNORED',
            'MANUALLY_EXPIRED',
        ]),
        extras: (_a = faker_1.faker.helpers.maybe(() => Object.fromEntries(faker_1.faker.helpers
            .arrayElements(faker_1.faker.lorem.words().split(' '), { min: 1, max: 5 })
            .map((word) => [word, faker_1.faker.string.alpha()])))) !== null && _a !== void 0 ? _a : null,
        created_at: faker_1.faker.date.recent({ days: 30 }).toISOString(),
        last_updated_at: faker_1.faker.date.recent({ days: 30 }).toISOString(),
    };
}
function fakeMicrotaskAssignment() {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
    return {
        id: faker_1.faker.number.bigInt().toString(),
        old_id: (_a = faker_1.faker.helpers.maybe(() => faker_1.faker.string.uuid().replace(/-/g, '').slice(0, 50))) !== null && _a !== void 0 ? _a : null,
        box_id: faker_1.faker.number.bigInt().toString(),
        local_id: (_b = faker_1.faker.helpers.maybe(() => faker_1.faker.number.bigInt().toString())) !== null && _b !== void 0 ? _b : null,
        project_id: faker_1.faker.number.bigInt().toString(),
        batch_id: (_c = faker_1.faker.helpers.maybe(() => faker_1.faker.string.uuid().replace(/-/g, '').slice(0, 32))) !== null && _c !== void 0 ? _c : null,
        microtask_id: faker_1.faker.number.bigInt().toString(),
        task_id: faker_1.faker.number.bigInt().toString(),
        avatar_id: faker_1.faker.number.bigInt().toString(),
        worker_id: faker_1.faker.number.bigInt().toString(),
        test: faker_1.faker.datatype.boolean(),
        is_gold: faker_1.faker.datatype.boolean(),
        wgroup: (_d = faker_1.faker.helpers.maybe(() => faker_1.faker.lorem.words({ min: 2, max: 10 }).slice(0, 64))) !== null && _d !== void 0 ? _d : null,
        sent_to_server_at: faker_1.faker.date.recent({ days: 30 }).toISOString(),
        deadline: (_e = faker_1.faker.helpers.maybe(() => faker_1.faker.date.recent({ days: 30 }).toISOString())) !== null && _e !== void 0 ? _e : null,
        status: faker_1.faker.helpers.arrayElement([
            'ASSIGNED',
            'COMPLETED',
            'SUBMITTED',
            'SKIPPED',
            'EXPIRED',
            'VERIFIED',
            'IGNORED',
            'MANUALLY_EXPIRED',
        ]),
        completed_at: (_f = faker_1.faker.helpers.maybe(() => faker_1.faker.date.recent({ days: 30 }).toISOString())) !== null && _f !== void 0 ? _f : null,
        output: (_g = faker_1.faker.helpers.maybe(() => Object.fromEntries(faker_1.faker.helpers
            .arrayElements(faker_1.faker.lorem.words().split(' '), { min: 1, max: 5 })
            .map((word) => [word, faker_1.faker.string.alpha()])))) !== null && _g !== void 0 ? _g : null,
        output_file_id: (_h = faker_1.faker.helpers.maybe(() => faker_1.faker.string.uuid().replace(/-/g, '').slice(0, 50))) !== null && _h !== void 0 ? _h : null,
        logs: (_j = faker_1.faker.helpers.maybe(() => ({
            logs: faker_1.faker.helpers.arrayElements(faker_1.faker.lorem.words().split(' '), { min: 1, max: 5 }),
        }))) !== null && _j !== void 0 ? _j : null,
        submitted_to_box_at: (_k = faker_1.faker.helpers.maybe(() => faker_1.faker.date.recent({ days: 30 }).toISOString())) !== null && _k !== void 0 ? _k : null,
        submitted_to_server_at: (_l = faker_1.faker.helpers.maybe(() => faker_1.faker.date.recent({ days: 30 }).toISOString())) !== null && _l !== void 0 ? _l : null,
        verified_at: (_m = faker_1.faker.helpers.maybe(() => faker_1.faker.date.recent({ days: 30 }).toISOString())) !== null && _m !== void 0 ? _m : null,
        report: (_o = faker_1.faker.helpers.maybe(() => Object.fromEntries(faker_1.faker.helpers
            .arrayElements(faker_1.faker.lorem.words().split(' '), { min: 1, max: 5 })
            .map((word) => [word, faker_1.faker.string.alpha()])))) !== null && _o !== void 0 ? _o : null,
        max_base_credits: faker_1.faker.number.int(),
        base_credits: faker_1.faker.number.int(),
        max_credits: faker_1.faker.number.int(),
        credits: (_p = faker_1.faker.helpers.maybe(() => faker_1.faker.number.int())) !== null && _p !== void 0 ? _p : null,
        accepted: (_q = faker_1.faker.helpers.maybe(() => faker_1.faker.datatype.boolean())) !== null && _q !== void 0 ? _q : null,
        extras: (_r = faker_1.faker.helpers.maybe(() => Object.fromEntries(faker_1.faker.helpers
            .arrayElements(faker_1.faker.lorem.words().split(' '), { min: 1, max: 5 })
            .map((word) => [word, faker_1.faker.string.alpha()])))) !== null && _r !== void 0 ? _r : null,
        created_at: faker_1.faker.date.recent({ days: 30 }).toISOString(),
        last_updated_at: faker_1.faker.date.recent({ days: 30 }).toISOString(),
    };
}
function fakeMicrotaskAssignmentBatch() {
    var _a, _b, _c, _d;
    return {
        id: faker_1.faker.number.bigInt().toString(),
        project_id: faker_1.faker.number.bigInt().toString(),
        task_id: faker_1.faker.number.bigInt().toString(),
        size: faker_1.faker.number.int(),
        status: faker_1.faker.helpers.arrayElement(['UNALLOCATED', 'ALLOCATED', 'INVALIDATED']),
        claimed_avatar_id: (_a = faker_1.faker.helpers.maybe(() => faker_1.faker.number.bigInt().toString())) !== null && _a !== void 0 ? _a : null,
        claimed_worker_id: (_b = faker_1.faker.helpers.maybe(() => faker_1.faker.number.bigInt().toString())) !== null && _b !== void 0 ? _b : null,
        claimed_at: (_c = faker_1.faker.helpers.maybe(() => faker_1.faker.date.recent({ days: 30 }).toISOString())) !== null && _c !== void 0 ? _c : null,
        extras: (_d = faker_1.faker.helpers.maybe(() => Object.fromEntries(faker_1.faker.helpers
            .arrayElements(faker_1.faker.lorem.words().split(' '), { min: 1, max: 5 })
            .map((word) => [word, faker_1.faker.string.alpha()])))) !== null && _d !== void 0 ? _d : null,
        created_at: faker_1.faker.date.recent({ days: 30 }).toISOString(),
        last_updated_at: faker_1.faker.date.recent({ days: 30 }).toISOString(),
    };
}
function fakeMicrotaskAssignmentBatchMember() {
    var _a;
    return {
        id: faker_1.faker.number.bigInt().toString(),
        batch_id: faker_1.faker.number.bigInt().toString(),
        microtask_id: faker_1.faker.number.bigInt().toString(),
        ord: faker_1.faker.number.int(),
        released_at: (_a = faker_1.faker.helpers.maybe(() => faker_1.faker.date.recent({ days: 30 }).toISOString())) !== null && _a !== void 0 ? _a : null,
        created_at: faker_1.faker.date.recent({ days: 30 }).toISOString(),
        last_updated_at: faker_1.faker.date.recent({ days: 30 }).toISOString(),
    };
}
function fakeScriptOp() {
    var _a, _b, _c, _d, _e;
    return {
        id: faker_1.faker.number.bigInt().toString(),
        script_id: faker_1.faker.string.uuid().replace(/-/g, '').slice(0, 64),
        project_id: faker_1.faker.number.bigInt().toString(),
        description: (_a = faker_1.faker.helpers.maybe(() => faker_1.faker.lorem.paragraph())) !== null && _a !== void 0 ? _a : null,
        params: Object.fromEntries(faker_1.faker.helpers
            .arrayElements(faker_1.faker.lorem.words().split(' '), { min: 1, max: 5 })
            .map((word) => [word, faker_1.faker.string.alpha()])),
        status: faker_1.faker.helpers.arrayElement(['CREATED', 'RUNNING', 'COMPLETED', 'FAILED']),
        stdout: (_b = faker_1.faker.helpers.maybe(() => faker_1.faker.lorem.paragraph())) !== null && _b !== void 0 ? _b : null,
        stderr: (_c = faker_1.faker.helpers.maybe(() => faker_1.faker.lorem.paragraph())) !== null && _c !== void 0 ? _c : null,
        error: (_d = faker_1.faker.helpers.maybe(() => Object.fromEntries(faker_1.faker.helpers
            .arrayElements(faker_1.faker.lorem.words().split(' '), { min: 1, max: 5 })
            .map((word) => [word, faker_1.faker.string.alpha()])))) !== null && _d !== void 0 ? _d : null,
        extras: (_e = faker_1.faker.helpers.maybe(() => Object.fromEntries(faker_1.faker.helpers
            .arrayElements(faker_1.faker.lorem.words().split(' '), { min: 1, max: 5 })
            .map((word) => [word, faker_1.faker.string.alpha()])))) !== null && _e !== void 0 ? _e : null,
        created_at: faker_1.faker.date.recent({ days: 30 }).toISOString(),
        last_updated_at: faker_1.faker.date.recent({ days: 30 }).toISOString(),
    };
}
function fakeReferral() {
    var _a, _b;
    return {
        id: faker_1.faker.number.bigInt().toString(),
        project_id: faker_1.faker.number.bigInt().toString(),
        worker_id: faker_1.faker.number.bigInt().toString(),
        referred_task_id: faker_1.faker.number.bigInt().toString(),
        referred_phone_number: faker_1.faker.phone.number({ style: 'international' }),
        status: faker_1.faker.helpers.arrayElement(['SENT', 'FAILED', 'ACCEPTED']),
        failure_reason: (_a = faker_1.faker.helpers.maybe(() => faker_1.faker.lorem.words({ min: 2, max: 10 }).slice(0, 64))) !== null && _a !== void 0 ? _a : null,
        extras: (_b = faker_1.faker.helpers.maybe(() => Object.fromEntries(faker_1.faker.helpers
            .arrayElements(faker_1.faker.lorem.words().split(' '), { min: 1, max: 5 })
            .map((word) => [word, faker_1.faker.string.alpha()])))) !== null && _b !== void 0 ? _b : null,
        created_at: faker_1.faker.date.recent({ days: 30 }).toISOString(),
        last_updated_at: faker_1.faker.date.recent({ days: 30 }).toISOString(),
    };
}
function fakeAdditionalPayment() {
    var _a, _b;
    return {
        id: faker_1.faker.number.bigInt().toString(),
        worker_id: faker_1.faker.number.bigInt().toString(),
        project_id: faker_1.faker.number.bigInt().toString(),
        amount: faker_1.faker.number.int(),
        description: (_a = faker_1.faker.helpers.maybe(() => faker_1.faker.lorem.words({ min: 2, max: 10 }).slice(0, 64))) !== null && _a !== void 0 ? _a : null,
        added_by: faker_1.faker.number.bigInt().toString(),
        extras: (_b = faker_1.faker.helpers.maybe(() => Object.fromEntries(faker_1.faker.helpers
            .arrayElements(faker_1.faker.lorem.words().split(' '), { min: 1, max: 5 })
            .map((word) => [word, faker_1.faker.string.alpha()])))) !== null && _b !== void 0 ? _b : null,
        created_at: faker_1.faker.date.recent({ days: 30 }).toISOString(),
        last_updated_at: faker_1.faker.date.recent({ days: 30 }).toISOString(),
    };
}
function fakeDeviceRestriction() {
    var _a, _b, _c;
    return {
        id: faker_1.faker.number.bigInt().toString(),
        device_id_hash: faker_1.faker.string.uuid().replace(/-/g, '').slice(0, 64),
        task_id: faker_1.faker.number.bigInt().toString(),
        allowed_users: (_a = faker_1.faker.helpers.maybe(() => faker_1.faker.number.int())) !== null && _a !== void 0 ? _a : null,
        description: (_b = faker_1.faker.helpers.maybe(() => faker_1.faker.lorem.words({ min: 2, max: 10 }).slice(0, 64))) !== null && _b !== void 0 ? _b : null,
        added_by: faker_1.faker.number.bigInt().toString(),
        extras: (_c = faker_1.faker.helpers.maybe(() => Object.fromEntries(faker_1.faker.helpers
            .arrayElements(faker_1.faker.lorem.words().split(' '), { min: 1, max: 5 })
            .map((word) => [word, faker_1.faker.string.alpha()])))) !== null && _c !== void 0 ? _c : null,
        created_at: faker_1.faker.date.recent({ days: 30 }).toISOString(),
        last_updated_at: faker_1.faker.date.recent({ days: 30 }).toISOString(),
    };
}
function fakeFundAccountRestriction() {
    var _a, _b, _c;
    return {
        id: faker_1.faker.number.bigInt().toString(),
        credentials_hash: faker_1.faker.lorem.words({ min: 2, max: 10 }).slice(0, 64),
        no_of_users_per_account: (_a = faker_1.faker.helpers.maybe(() => faker_1.faker.number.int())) !== null && _a !== void 0 ? _a : null,
        description: (_b = faker_1.faker.helpers.maybe(() => faker_1.faker.lorem.paragraph())) !== null && _b !== void 0 ? _b : null,
        added_by: faker_1.faker.number.bigInt().toString(),
        extras: (_c = faker_1.faker.helpers.maybe(() => Object.fromEntries(faker_1.faker.helpers
            .arrayElements(faker_1.faker.lorem.words().split(' '), { min: 1, max: 5 })
            .map((word) => [word, faker_1.faker.string.alpha()])))) !== null && _c !== void 0 ? _c : null,
        created_at: faker_1.faker.date.recent({ days: 30 }).toISOString(),
        last_updated_at: faker_1.faker.date.recent({ days: 30 }).toISOString(),
    };
}
function fakeTicket() {
    var _a, _b;
    return {
        id: faker_1.faker.number.bigInt().toString(),
        project_id: faker_1.faker.number.bigInt().toString(),
        provider_ticket_id: faker_1.faker.string.uuid().replace(/-/g, '').slice(0, 256),
        worker_id: faker_1.faker.number.bigInt().toString(),
        category: (_a = faker_1.faker.helpers.maybe(() => faker_1.faker.helpers.arrayElement(['TASK', 'BUG', 'NEW_FEATURE', 'IMPROVEMENT']))) !== null && _a !== void 0 ? _a : null,
        extras: (_b = faker_1.faker.helpers.maybe(() => Object.fromEntries(faker_1.faker.helpers
            .arrayElements(faker_1.faker.lorem.words().split(' '), { min: 1, max: 5 })
            .map((word) => [word, faker_1.faker.string.alpha()])))) !== null && _b !== void 0 ? _b : null,
        created_at: faker_1.faker.date.recent({ days: 30 }).toISOString(),
        last_updated_at: faker_1.faker.date.recent({ days: 30 }).toISOString(),
    };
}
function fakeClients() {
    return {
        id: faker_1.faker.number.bigInt().toString(),
        name: faker_1.faker.lorem.paragraph(),
        api_key: faker_1.faker.lorem.paragraph(),
        id_token: faker_1.faker.lorem.paragraph(),
        created_at: faker_1.faker.date.recent({ days: 30 }).toISOString(),
        last_updated_at: faker_1.faker.date.recent({ days: 30 }).toISOString(),
    };
}
function fakeReports() {
    return {
        id: faker_1.faker.number.bigInt().toString(),
        kind: faker_1.faker.helpers.arrayElement(['platform', 'project', 'task', 'worker', 'miscellaneous', 'graphs']),
        name: faker_1.faker.lorem.paragraph(),
        type: faker_1.faker.helpers.arrayElement(['static', 'dynamic']),
        sql_query: faker_1.faker.lorem.paragraph(),
        config: Object.fromEntries(faker_1.faker.helpers
            .arrayElements(faker_1.faker.lorem.words().split(' '), { min: 1, max: 5 })
            .map((word) => [word, faker_1.faker.string.alpha()])),
        is_public: faker_1.faker.datatype.boolean(),
        is_disabled: faker_1.faker.datatype.boolean(),
        is_clickhouse_query: faker_1.faker.datatype.boolean(),
        created_by: faker_1.faker.number.bigInt().toString(),
        last_updated_by: faker_1.faker.number.bigInt().toString(),
        created_at: faker_1.faker.date.recent({ days: 30 }).toISOString(),
        last_updated_at: faker_1.faker.date.recent({ days: 30 }).toISOString(),
    };
}
function fakeClientReports() {
    return {
        id: faker_1.faker.number.bigInt().toString(),
        client_id: faker_1.faker.number.bigInt().toString(),
        report_id: faker_1.faker.number.bigInt().toString(),
        created_at: faker_1.faker.date.recent({ days: 30 }).toISOString(),
        last_updated_at: faker_1.faker.date.recent({ days: 30 }).toISOString(),
    };
}
function fakeConferencer() {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
    return {
        id: faker_1.faker.string.uuid().replace(/-/g, '').slice(0, 50),
        caller_number: faker_1.faker.lorem.words({ min: 2, max: 10 }).slice(0, 13),
        callee_number: faker_1.faker.lorem.words({ min: 2, max: 10 }).slice(0, 13),
        project_id: faker_1.faker.number.bigInt().toString(),
        task_id: faker_1.faker.number.bigInt().toString(),
        caller_mta: faker_1.faker.number.bigInt().toString(),
        callee_mta: faker_1.faker.lorem.words({ min: 2, max: 10 }).slice(0, 50),
        meta: (_a = faker_1.faker.helpers.maybe(() => Object.fromEntries(faker_1.faker.helpers
            .arrayElements(faker_1.faker.lorem.words().split(' '), { min: 1, max: 5 })
            .map((word) => [word, faker_1.faker.string.alpha()])))) !== null && _a !== void 0 ? _a : null,
        acknowledgement_status: faker_1.faker.helpers.arrayElement(['PENDING', 'ACCEPTED', 'REJECTED', 'EXPIRED']),
        call_status: (_b = faker_1.faker.helpers.maybe(() => faker_1.faker.helpers.arrayElement([
            'CANCELLED',
            'INITIATED',
            'UNANSWERED_CALLER',
            'UNANSWERED_CALLEE',
            'BUSY_CALLER',
            'BUSY_CALLEE',
            'REJECTED_BY_CALLER',
            'REJECTED_BY_CALLEE',
            'RINGING_CALLER',
            'RINGING_CALLEE',
            'RECORDING',
            'COMPLETED',
            'FAILED',
        ]))) !== null && _b !== void 0 ? _b : null,
        callee_response_to_call: (_c = faker_1.faker.helpers.maybe(() => faker_1.faker.helpers.arrayElement(['ACCEPTED', 'REJECTED']))) !== null && _c !== void 0 ? _c : null,
        provider_action_on_call: (_d = faker_1.faker.helpers.maybe(() => faker_1.faker.helpers.arrayElement(['SESSION_TIMEOUT', 'MEETING_ROOM_DELETED', 'RING_TIMEOUT_EXPIRED']))) !== null && _d !== void 0 ? _d : null,
        participants_in_room: (_e = faker_1.faker.helpers.maybe(() => faker_1.faker.number.int())) !== null && _e !== void 0 ? _e : null,
        caller_start_call_at: (_f = faker_1.faker.helpers.maybe(() => faker_1.faker.date.recent({ days: 30 }).toISOString())) !== null && _f !== void 0 ? _f : null,
        callee_response_to_call_at: (_g = faker_1.faker.helpers.maybe(() => faker_1.faker.date.recent({ days: 30 }).toISOString())) !== null && _g !== void 0 ? _g : null,
        provider_action_on_call_at: (_h = faker_1.faker.helpers.maybe(() => faker_1.faker.date.recent({ days: 30 }).toISOString())) !== null && _h !== void 0 ? _h : null,
        caller_rejected_at: (_j = faker_1.faker.helpers.maybe(() => faker_1.faker.date.recent({ days: 30 }).toISOString())) !== null && _j !== void 0 ? _j : null,
        caller_hangup_at: (_k = faker_1.faker.helpers.maybe(() => faker_1.faker.date.recent({ days: 30 }).toISOString())) !== null && _k !== void 0 ? _k : null,
        callee_hangup_at: (_l = faker_1.faker.helpers.maybe(() => faker_1.faker.date.recent({ days: 30 }).toISOString())) !== null && _l !== void 0 ? _l : null,
        recording_meta: (_m = faker_1.faker.helpers.maybe(() => Object.fromEntries(faker_1.faker.helpers
            .arrayElements(faker_1.faker.lorem.words().split(' '), { min: 1, max: 5 })
            .map((word) => [word, faker_1.faker.string.alpha()])))) !== null && _m !== void 0 ? _m : null,
        extras: (_o = faker_1.faker.helpers.maybe(() => Object.fromEntries(faker_1.faker.helpers
            .arrayElements(faker_1.faker.lorem.words().split(' '), { min: 1, max: 5 })
            .map((word) => [word, faker_1.faker.string.alpha()])))) !== null && _o !== void 0 ? _o : null,
        created_at: faker_1.faker.date.recent({ days: 30 }).toISOString(),
        last_updated_at: faker_1.faker.date.recent({ days: 30 }).toISOString(),
    };
}
function fakeFundAccount() {
    var _a;
    return {
        id: faker_1.faker.number.bigInt().toString(),
        user_id: faker_1.faker.number.bigInt().toString(),
        credentials: faker_1.faker.lorem.words({ min: 2, max: 10 }).slice(0, 50),
        credentials_hash: faker_1.faker.lorem.words({ min: 2, max: 10 }).slice(0, 64),
        account_type: faker_1.faker.helpers.arrayElement(['BANK_ACCOUNT', 'VPA']),
        status: faker_1.faker.helpers.arrayElement(['CREATED', 'PENDING_VERIFICATION', 'VERIFIED', 'REJECTED', 'FAILED']),
        verified_count: faker_1.faker.number.int(),
        transaction_in_progress: faker_1.faker.datatype.boolean(),
        props: Object.fromEntries(faker_1.faker.helpers
            .arrayElements(faker_1.faker.lorem.words().split(' '), { min: 1, max: 5 })
            .map((word) => [word, faker_1.faker.string.alpha()])),
        meta: (_a = faker_1.faker.helpers.maybe(() => Object.fromEntries(faker_1.faker.helpers
            .arrayElements(faker_1.faker.lorem.words().split(' '), { min: 1, max: 5 })
            .map((word) => [word, faker_1.faker.string.alpha()])))) !== null && _a !== void 0 ? _a : null,
        created_at: faker_1.faker.date.recent({ days: 30 }).toISOString(),
        last_updated_at: faker_1.faker.date.recent({ days: 30 }).toISOString(),
    };
}
function fakeTransaction() {
    var _a, _b, _c;
    return {
        id: faker_1.faker.string.uuid().replace(/-/g, '').slice(0, 50),
        amount: faker_1.faker.number.int(),
        tds_amount: faker_1.faker.number.int(),
        status: faker_1.faker.helpers.arrayElement(['CREATED', 'PROCESSING', 'PROCESSED', 'FAILED']),
        purpose: faker_1.faker.helpers.arrayElement(['PAYMENT', 'VERIFICATION']),
        payment_method: faker_1.faker.helpers.arrayElement(['UPI', 'NEFT', 'IMPS', 'RTGS', 'EFT']),
        payment_gateway_provider: faker_1.faker.helpers.arrayElement(['ICICI', 'CASHFREE', 'PEACH']),
        financial_year: faker_1.faker.lorem.words({ min: 2, max: 10 }).slice(0, 10),
        provider_transaction_id: (_a = faker_1.faker.helpers.maybe(() => faker_1.faker.string.uuid().replace(/-/g, '').slice(0, 50))) !== null && _a !== void 0 ? _a : null,
        fund_account_id: faker_1.faker.number.bigInt().toString(),
        user_id: faker_1.faker.number.bigInt().toString(),
        project_id: faker_1.faker.number.bigInt().toString(),
        bulk_transaction_id: (_b = faker_1.faker.helpers.maybe(() => faker_1.faker.string.uuid().replace(/-/g, '').slice(0, 50))) !== null && _b !== void 0 ? _b : null,
        idempotency_key: faker_1.faker.string.uuid().replace(/-/g, '').slice(0, 50),
        created_by_user_id: faker_1.faker.number.bigInt().toString(),
        props: Object.fromEntries(faker_1.faker.helpers
            .arrayElements(faker_1.faker.lorem.words().split(' '), { min: 1, max: 5 })
            .map((word) => [word, faker_1.faker.string.alpha()])),
        meta: (_c = faker_1.faker.helpers.maybe(() => Object.fromEntries(faker_1.faker.helpers
            .arrayElements(faker_1.faker.lorem.words().split(' '), { min: 1, max: 5 })
            .map((word) => [word, faker_1.faker.string.alpha()])))) !== null && _c !== void 0 ? _c : null,
        created_at: faker_1.faker.date.recent({ days: 30 }).toISOString(),
        last_updated_at: faker_1.faker.date.recent({ days: 30 }).toISOString(),
    };
}
function fakeBulkTransaction() {
    var _a;
    return {
        id: faker_1.faker.string.uuid().replace(/-/g, '').slice(0, 50),
        amount: faker_1.faker.number.int(),
        status: faker_1.faker.helpers.arrayElement(['CREATED', 'ALL_REGISTERED', 'PARTIALLY_REGISTERED', 'NOT_REGISTERED']),
        n_transactions: faker_1.faker.number.int(),
        financial_year: faker_1.faker.lorem.words({ min: 2, max: 10 }).slice(0, 10),
        project_id: faker_1.faker.number.bigInt().toString(),
        created_by_user_id: faker_1.faker.number.bigInt().toString(),
        props: Object.fromEntries(faker_1.faker.helpers
            .arrayElements(faker_1.faker.lorem.words().split(' '), { min: 1, max: 5 })
            .map((word) => [word, faker_1.faker.string.alpha()])),
        meta: (_a = faker_1.faker.helpers.maybe(() => Object.fromEntries(faker_1.faker.helpers
            .arrayElements(faker_1.faker.lorem.words().split(' '), { min: 1, max: 5 })
            .map((word) => [word, faker_1.faker.string.alpha()])))) !== null && _a !== void 0 ? _a : null,
        created_at: faker_1.faker.date.recent({ days: 30 }).toISOString(),
        last_updated_at: faker_1.faker.date.recent({ days: 30 }).toISOString(),
    };
}
function fakePaymentTransactionJobs() {
    var _a, _b;
    return {
        id: faker_1.faker.number.bigInt().toString(),
        status: faker_1.faker.helpers.arrayElement(['CREATED', 'PICKED', 'COMPLETED']),
        payload: Object.fromEntries(faker_1.faker.helpers
            .arrayElements(faker_1.faker.lorem.words().split(' '), { min: 1, max: 5 })
            .map((word) => [word, faker_1.faker.string.alpha()])),
        picked_at: (_a = faker_1.faker.helpers.maybe(() => faker_1.faker.date.recent({ days: 30 }).toISOString())) !== null && _a !== void 0 ? _a : null,
        completed_at: (_b = faker_1.faker.helpers.maybe(() => faker_1.faker.date.recent({ days: 30 }).toISOString())) !== null && _b !== void 0 ? _b : null,
        created_at: faker_1.faker.date.recent({ days: 30 }).toISOString(),
        last_updated_at: faker_1.faker.date.recent({ days: 30 }).toISOString(),
    };
}
function fakeSevaUser() {
    var _a;
    return {
        id: faker_1.faker.number.bigInt().toString(),
        messaging_id: faker_1.faker.string.uuid().replace(/-/g, '').slice(0, 100),
        extras: (_a = faker_1.faker.helpers.maybe(() => Object.fromEntries(faker_1.faker.helpers
            .arrayElements(faker_1.faker.lorem.words().split(' '), { min: 1, max: 5 })
            .map((word) => [word, faker_1.faker.string.alpha()])))) !== null && _a !== void 0 ? _a : null,
        created_at: faker_1.faker.date.recent({ days: 30 }).toISOString(),
        last_updated_at: faker_1.faker.date.recent({ days: 30 }).toISOString(),
    };
}
function fakeSevaUserTickets() {
    var _a;
    return {
        karya_ticket_id: faker_1.faker.string.uuid().replace(/-/g, '').slice(0, 50),
        seva_user_id: faker_1.faker.number.bigInt().toString(),
        provider_ticket_id: faker_1.faker.string.uuid().replace(/-/g, '').slice(0, 50),
        extras: (_a = faker_1.faker.helpers.maybe(() => Object.fromEntries(faker_1.faker.helpers
            .arrayElements(faker_1.faker.lorem.words().split(' '), { min: 1, max: 5 })
            .map((word) => [word, faker_1.faker.string.alpha()])))) !== null && _a !== void 0 ? _a : null,
        created_at: faker_1.faker.date.recent({ days: 30 }).toISOString(),
        last_updated_at: faker_1.faker.date.recent({ days: 30 }).toISOString(),
    };
}
function fakeEligibleUsersQuery() {
    var _a;
    return {
        id: faker_1.faker.number.bigInt().toString(),
        name: faker_1.faker.lorem.words({ min: 2, max: 10 }).slice(0, 128),
        query: faker_1.faker.lorem.paragraph(),
        extras: (_a = faker_1.faker.helpers.maybe(() => Object.fromEntries(faker_1.faker.helpers
            .arrayElements(faker_1.faker.lorem.words().split(' '), { min: 1, max: 5 })
            .map((word) => [word, faker_1.faker.string.alpha()])))) !== null && _a !== void 0 ? _a : null,
        created_at: faker_1.faker.date.recent({ days: 30 }).toISOString(),
        last_updated_at: faker_1.faker.date.recent({ days: 30 }).toISOString(),
    };
}
function fakeForm() {
    var _a, _b, _c, _d, _e;
    return {
        id: faker_1.faker.number.bigInt().toString(),
        name: faker_1.faker.lorem.words({ min: 2, max: 10 }).slice(0, 128),
        display_name: faker_1.faker.lorem.words({ min: 2, max: 10 }).slice(0, 1024),
        status: faker_1.faker.helpers.arrayElement(['ACTIVE', 'INACTIVE']),
        content: (_a = faker_1.faker.helpers.maybe(() => Object.fromEntries(faker_1.faker.helpers
            .arrayElements(faker_1.faker.lorem.words().split(' '), { min: 1, max: 5 })
            .map((word) => [word, faker_1.faker.string.alpha()])))) !== null && _a !== void 0 ? _a : null,
        spec: Object.fromEntries(faker_1.faker.helpers
            .arrayElements(faker_1.faker.lorem.words().split(' '), { min: 1, max: 5 })
            .map((word) => [word, faker_1.faker.string.alpha()])),
        expiry: (_b = faker_1.faker.helpers.maybe(() => faker_1.faker.date.recent({ days: 30 }).toISOString())) !== null && _b !== void 0 ? _b : null,
        schedule_type: faker_1.faker.helpers.arrayElement(['FIXED', 'PERIODIC']),
        schedule_fixed_date: (_c = faker_1.faker.helpers.maybe(() => faker_1.faker.date.recent({ days: 30 }).toISOString())) !== null && _c !== void 0 ? _c : null,
        schedule_periodic_interval: (_d = faker_1.faker.helpers.maybe(() => faker_1.faker.helpers.arrayElement(['DAY', 'MONTH', 'QUARTER', 'YEAR']))) !== null && _d !== void 0 ? _d : null,
        eligible_users_query_id: faker_1.faker.number.bigInt().toString(),
        extras: (_e = faker_1.faker.helpers.maybe(() => Object.fromEntries(faker_1.faker.helpers
            .arrayElements(faker_1.faker.lorem.words().split(' '), { min: 1, max: 5 })
            .map((word) => [word, faker_1.faker.string.alpha()])))) !== null && _e !== void 0 ? _e : null,
        created_at: faker_1.faker.date.recent({ days: 30 }).toISOString(),
        last_updated_at: faker_1.faker.date.recent({ days: 30 }).toISOString(),
    };
}
function fakeFormAssignment() {
    var _a, _b, _c, _d, _e;
    return {
        id: faker_1.faker.number.bigInt().toString(),
        form_id: faker_1.faker.number.bigInt().toString(),
        worker_id: faker_1.faker.number.bigInt().toString(),
        status: faker_1.faker.helpers.arrayElement(['CREATED', 'ASSIGNED', 'SUBMITTED', 'EXPIRED']),
        output: (_a = faker_1.faker.helpers.maybe(() => Object.fromEntries(faker_1.faker.helpers
            .arrayElements(faker_1.faker.lorem.words().split(' '), { min: 1, max: 5 })
            .map((word) => [word, faker_1.faker.string.alpha()])))) !== null && _a !== void 0 ? _a : null,
        expires_at: (_b = faker_1.faker.helpers.maybe(() => faker_1.faker.date.recent({ days: 30 }).toISOString())) !== null && _b !== void 0 ? _b : null,
        assigned_at: (_c = faker_1.faker.helpers.maybe(() => faker_1.faker.date.recent({ days: 30 }).toISOString())) !== null && _c !== void 0 ? _c : null,
        submitted_at: (_d = faker_1.faker.helpers.maybe(() => faker_1.faker.date.recent({ days: 30 }).toISOString())) !== null && _d !== void 0 ? _d : null,
        extras: (_e = faker_1.faker.helpers.maybe(() => Object.fromEntries(faker_1.faker.helpers
            .arrayElements(faker_1.faker.lorem.words().split(' '), { min: 1, max: 5 })
            .map((word) => [word, faker_1.faker.string.alpha()])))) !== null && _e !== void 0 ? _e : null,
        created_at: faker_1.faker.date.recent({ days: 30 }).toISOString(),
        last_updated_at: faker_1.faker.date.recent({ days: 30 }).toISOString(),
    };
}
function fakeFormTrigger() {
    var _a, _b, _c, _d;
    return {
        id: faker_1.faker.number.bigInt().toString(),
        form_id: faker_1.faker.number.bigInt().toString(),
        trigger_type: faker_1.faker.helpers.arrayElement(['DISTRIBUTE', 'EXPIRE']),
        status: faker_1.faker.helpers.arrayElement(['RUNNING', 'COMPLETED', 'FAILED']),
        last_run_at: faker_1.faker.date.recent({ days: 30 }).toISOString(),
        completed_at: (_a = faker_1.faker.helpers.maybe(() => faker_1.faker.date.recent({ days: 30 }).toISOString())) !== null && _a !== void 0 ? _a : null,
        message: (_b = faker_1.faker.helpers.maybe(() => faker_1.faker.lorem.paragraph())) !== null && _b !== void 0 ? _b : null,
        eligibility_query_result_file: (_c = faker_1.faker.helpers.maybe(() => faker_1.faker.lorem.paragraph())) !== null && _c !== void 0 ? _c : null,
        extras: (_d = faker_1.faker.helpers.maybe(() => Object.fromEntries(faker_1.faker.helpers
            .arrayElements(faker_1.faker.lorem.words().split(' '), { min: 1, max: 5 })
            .map((word) => [word, faker_1.faker.string.alpha()])))) !== null && _d !== void 0 ? _d : null,
        created_at: faker_1.faker.date.recent({ days: 30 }).toISOString(),
        last_updated_at: faker_1.faker.date.recent({ days: 30 }).toISOString(),
    };
}
function fakeNotification() {
    var _a, _b, _c, _d, _e;
    return {
        id: faker_1.faker.number.bigInt().toString(),
        worker_id: faker_1.faker.number.bigInt().toString(),
        title: faker_1.faker.lorem.words({ min: 2, max: 10 }).slice(0, 256),
        body: faker_1.faker.lorem.paragraph(),
        status: faker_1.faker.helpers.arrayElement(['CREATED', 'SENT', 'FAILED', 'DELIVERED']),
        navigation_link: (_a = faker_1.faker.helpers.maybe(() => faker_1.faker.lorem.words({ min: 2, max: 10 }).slice(0, 512))) !== null && _a !== void 0 ? _a : null,
        has_action: faker_1.faker.datatype.boolean(),
        trigger_type: faker_1.faker.helpers.arrayElement(['AUTOMATED', 'MANUAL']),
        type: faker_1.faker.helpers.arrayElement([
            'MICROTASK_ASSIGNED',
            'AVATAR_LINKED',
            'REJECTED_ASSIGNMENTS',
            'TEST_TASK_PASSED',
            'TEST_TASK_FAILED',
            'MT_REASSIGNMENT',
            'MTA_VERIFICATION',
            'VOIP_INCOMING_CALL',
            'VOIP_REJECT_CALL',
            'WORKER_ID_ASSIGNED',
            'UNSPECIFIED',
        ]),
        extras: (_b = faker_1.faker.helpers.maybe(() => Object.fromEntries(faker_1.faker.helpers
            .arrayElements(faker_1.faker.lorem.words().split(' '), { min: 1, max: 5 })
            .map((word) => [word, faker_1.faker.string.alpha()])))) !== null && _b !== void 0 ? _b : null,
        seen_at: (_c = faker_1.faker.helpers.maybe(() => faker_1.faker.date.recent({ days: 30 }).toISOString())) !== null && _c !== void 0 ? _c : null,
        opened_at: (_d = faker_1.faker.helpers.maybe(() => faker_1.faker.date.recent({ days: 30 }).toISOString())) !== null && _d !== void 0 ? _d : null,
        delivered_at: (_e = faker_1.faker.helpers.maybe(() => faker_1.faker.date.recent({ days: 30 }).toISOString())) !== null && _e !== void 0 ? _e : null,
        created_at: faker_1.faker.date.recent({ days: 30 }).toISOString(),
        last_updated_at: faker_1.faker.date.recent({ days: 30 }).toISOString(),
    };
}
function fakeLearnTask() {
    var _a, _b, _c;
    return {
        id: faker_1.faker.number.bigInt().toString(),
        task_id: faker_1.faker.number.bigInt().toString(),
        stars: faker_1.faker.number.int(),
        duration_min: faker_1.faker.number.int(),
        duration_max: faker_1.faker.number.int(),
        language_requests: (_a = faker_1.faker.helpers.maybe(() => Object.fromEntries(faker_1.faker.helpers
            .arrayElements(faker_1.faker.lorem.words().split(' '), { min: 1, max: 5 })
            .map((word) => [word, faker_1.faker.string.alpha()])))) !== null && _a !== void 0 ? _a : null,
        retry_delay_days: (_b = faker_1.faker.helpers.maybe(() => faker_1.faker.number.int())) !== null && _b !== void 0 ? _b : null,
        max_task_retries: (_c = faker_1.faker.helpers.maybe(() => faker_1.faker.number.int())) !== null && _c !== void 0 ? _c : null,
        created_at: faker_1.faker.date.recent({ days: 30 }).toISOString(),
        last_updated_at: faker_1.faker.date.recent({ days: 30 }).toISOString(),
    };
}
function fakeLearnWorkerStats() {
    var _a, _b;
    return {
        id: faker_1.faker.number.bigInt().toString(),
        worker_id: faker_1.faker.number.bigInt().toString(),
        total_stars: faker_1.faker.number.int(),
        practice_task_attempts: (_a = faker_1.faker.helpers.maybe(() => Object.fromEntries(faker_1.faker.helpers
            .arrayElements(faker_1.faker.lorem.words().split(' '), { min: 1, max: 5 })
            .map((word) => [word, faker_1.faker.string.alpha()])))) !== null && _a !== void 0 ? _a : null,
        retry_tracking: (_b = faker_1.faker.helpers.maybe(() => Object.fromEntries(faker_1.faker.helpers
            .arrayElements(faker_1.faker.lorem.words().split(' '), { min: 1, max: 5 })
            .map((word) => [word, faker_1.faker.string.alpha()])))) !== null && _b !== void 0 ? _b : null,
        created_at: faker_1.faker.date.recent({ days: 30 }).toISOString(),
        last_updated_at: faker_1.faker.date.recent({ days: 30 }).toISOString(),
    };
}
function fakeOrgConfig() {
    var _a, _b, _c;
    return {
        id: faker_1.faker.number.bigInt().toString(),
        org_code: faker_1.faker.lorem.words({ min: 2, max: 10 }).slice(0, 32),
        org_name: faker_1.faker.lorem.words({ min: 2, max: 10 }).slice(0, 128),
        profile_task_id: (_a = faker_1.faker.helpers.maybe(() => faker_1.faker.number.bigInt().toString())) !== null && _a !== void 0 ? _a : null,
        require_profile_validation: faker_1.faker.datatype.boolean(),
        tds_enabled: faker_1.faker.datatype.boolean(),
        otp_provider: faker_1.faker.helpers.arrayElement(['2FACTOR', 'AFRO', 'TWILIO']),
        default_country_iso: faker_1.faker.lorem.words({ min: 2, max: 10 }).slice(0, 2),
        consent_markdown_link: (_b = faker_1.faker.helpers.maybe(() => faker_1.faker.lorem.words({ min: 2, max: 10 }).slice(0, 1024))) !== null && _b !== void 0 ? _b : null,
        hrs_markdown_link: (_c = faker_1.faker.helpers.maybe(() => faker_1.faker.lorem.words({ min: 2, max: 10 }).slice(0, 1024))) !== null && _c !== void 0 ? _c : null,
        created_at: faker_1.faker.date.recent({ days: 30 }).toISOString(),
        last_updated_at: faker_1.faker.date.recent({ days: 30 }).toISOString(),
    };
}
function fakeExternalServiceProviderConfig() {
    return {
        id: faker_1.faker.number.bigInt().toString(),
        name: faker_1.faker.lorem.words({ min: 2, max: 10 }).slice(0, 64),
        service_type: faker_1.faker.helpers.arrayElement([
            'PAYMENT',
            'OTP',
            'PAN_KYC',
            'AADHAAR_KYC',
            'VOIP',
            'TELECOM',
            'WHATSAPP',
            'TICKETING',
        ]),
        provider: faker_1.faker.string.uuid().replace(/-/g, '').slice(0, 32),
        config: Object.fromEntries(faker_1.faker.helpers
            .arrayElements(faker_1.faker.lorem.words().split(' '), { min: 1, max: 5 })
            .map((word) => [word, faker_1.faker.string.alpha()])),
        created_at: faker_1.faker.date.recent({ days: 30 }).toISOString(),
        last_updated_at: faker_1.faker.date.recent({ days: 30 }).toISOString(),
    };
}
function fakeOrgServiceProviderMapping() {
    return {
        id: faker_1.faker.number.bigInt().toString(),
        org_id: faker_1.faker.number.bigInt().toString(),
        service_type: faker_1.faker.helpers.arrayElement([
            'PAYMENT',
            'OTP',
            'PAN_KYC',
            'AADHAAR_KYC',
            'VOIP',
            'TELECOM',
            'WHATSAPP',
            'TICKETING',
        ]),
        service_provider_config_id: faker_1.faker.number.bigInt().toString(),
        created_at: faker_1.faker.date.recent({ days: 30 }).toISOString(),
        last_updated_at: faker_1.faker.date.recent({ days: 30 }).toISOString(),
    };
}
function fakeOrgPaymentConfig() {
    return {
        id: faker_1.faker.number.bigInt().toString(),
        org_id: faker_1.faker.number.bigInt().toString(),
        payment_provider: faker_1.faker.helpers.arrayElement(['ICICI', 'CASHFREE', 'PEACH']),
        currency: faker_1.faker.lorem.words({ min: 2, max: 10 }).slice(0, 3),
        credits_per_currency_unit: faker_1.faker.number.int(),
        credit_unit_label: faker_1.faker.lorem.words({ min: 2, max: 10 }).slice(0, 32),
        payout_unit_label: faker_1.faker.lorem.words({ min: 2, max: 10 }).slice(0, 32),
        currency_symbol: faker_1.faker.lorem.words({ min: 2, max: 10 }).slice(0, 8),
        min_payout_limit: faker_1.faker.number.int(),
        max_payout_limit: faker_1.faker.number.int(),
        verification_amount: faker_1.faker.number.int(),
        created_at: faker_1.faker.date.recent({ days: 30 }).toISOString(),
        last_updated_at: faker_1.faker.date.recent({ days: 30 }).toISOString(),
    };
}
function fakePaymentProviderAccountConfigs() {
    return {
        payment_provider: faker_1.faker.helpers.arrayElement(['ICICI', 'CASHFREE', 'PEACH']),
        account_type: faker_1.faker.helpers.arrayElement(['BANK_ACCOUNT', 'VPA']),
        fields: Object.fromEntries(faker_1.faker.helpers
            .arrayElements(faker_1.faker.lorem.words().split(' '), { min: 1, max: 5 })
            .map((word) => [word, faker_1.faker.string.alpha()])),
        created_at: faker_1.faker.date.recent({ days: 30 }).toISOString(),
        last_updated_at: faker_1.faker.date.recent({ days: 30 }).toISOString(),
    };
}
function fakeBulkTransactionTask() {
    return {
        id: faker_1.faker.number.bigInt().toString(),
        bulk_transaction_id: faker_1.faker.string.uuid().replace(/-/g, '').slice(0, 50),
        task_id: faker_1.faker.number.bigInt().toString(),
        project_id: faker_1.faker.number.bigInt().toString(),
        n_workers: faker_1.faker.number.int(),
        total_amount: faker_1.faker.number.int(),
        created_at: faker_1.faker.date.recent({ days: 30 }).toISOString(),
        last_updated_at: faker_1.faker.date.recent({ days: 30 }).toISOString(),
    };
}
function fakeWorkerTaskPayment() {
    return {
        id: faker_1.faker.number.bigInt().toString(),
        worker_id: faker_1.faker.number.bigInt().toString(),
        task_id: faker_1.faker.number.bigInt().toString(),
        project_id: faker_1.faker.number.bigInt().toString(),
        transaction_id: faker_1.faker.string.uuid().replace(/-/g, '').slice(0, 50),
        bulk_transaction_id: faker_1.faker.string.uuid().replace(/-/g, '').slice(0, 50),
        amount: faker_1.faker.number.int(),
        tds_amount: faker_1.faker.number.int(),
        created_at: faker_1.faker.date.recent({ days: 30 }).toISOString(),
        last_updated_at: faker_1.faker.date.recent({ days: 30 }).toISOString(),
    };
}
function fakeWorkerKyc() {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v;
    return {
        id: faker_1.faker.number.bigInt().toString(),
        worker_id: faker_1.faker.number.bigInt().toString(),
        kyc_status: faker_1.faker.helpers.arrayElement(['NOT_STARTED', 'IN_PROGRESS', 'PROCESSING', 'COMPLETED', 'FAILED']),
        document_type: (_a = faker_1.faker.helpers.maybe(() => faker_1.faker.helpers.arrayElement(['PAN', 'AADHAAR']))) !== null && _a !== void 0 ? _a : null,
        provider_session_id: (_b = faker_1.faker.helpers.maybe(() => faker_1.faker.lorem.paragraph())) !== null && _b !== void 0 ? _b : null,
        provider_form_link: (_c = faker_1.faker.helpers.maybe(() => faker_1.faker.lorem.paragraph())) !== null && _c !== void 0 ? _c : null,
        session_expires_at: (_d = faker_1.faker.helpers.maybe(() => faker_1.faker.date.recent({ days: 30 }).toISOString())) !== null && _d !== void 0 ? _d : null,
        name_from_kyc: (_e = faker_1.faker.helpers.maybe(() => faker_1.faker.lorem.paragraph())) !== null && _e !== void 0 ? _e : null,
        dob_from_kyc: (_f = faker_1.faker.helpers.maybe(() => faker_1.faker.lorem.paragraph())) !== null && _f !== void 0 ? _f : null,
        gender_from_kyc: (_g = faker_1.faker.helpers.maybe(() => faker_1.faker.lorem.paragraph())) !== null && _g !== void 0 ? _g : null,
        address_from_kyc: (_h = faker_1.faker.helpers.maybe(() => Object.fromEntries(faker_1.faker.helpers
            .arrayElements(faker_1.faker.lorem.words().split(' '), { min: 1, max: 5 })
            .map((word) => [word, faker_1.faker.string.alpha()])))) !== null && _h !== void 0 ? _h : null,
        document_verification_details: (_j = faker_1.faker.helpers.maybe(() => Object.fromEntries(faker_1.faker.helpers
            .arrayElements(faker_1.faker.lorem.words().split(' '), { min: 1, max: 5 })
            .map((word) => [word, faker_1.faker.string.alpha()])))) !== null && _j !== void 0 ? _j : null,
        document_number_hash: (_k = faker_1.faker.helpers.maybe(() => faker_1.faker.lorem.paragraph())) !== null && _k !== void 0 ? _k : null,
        document_number_hash_reliable: (_l = faker_1.faker.helpers.maybe(() => faker_1.faker.datatype.boolean())) !== null && _l !== void 0 ? _l : null,
        document_number_encrypted: (_m = faker_1.faker.helpers.maybe(() => faker_1.faker.lorem.paragraph())) !== null && _m !== void 0 ? _m : null,
        name_match_result: (_o = faker_1.faker.helpers.maybe(() => faker_1.faker.helpers.arrayElement(['MATCH', 'MISMATCH', 'SKIPPED']))) !== null && _o !== void 0 ? _o : null,
        name_similarity_score: (_p = faker_1.faker.helpers.maybe(() => faker_1.faker.number.float())) !== null && _p !== void 0 ? _p : null,
        gender_match_result: (_q = faker_1.faker.helpers.maybe(() => faker_1.faker.helpers.arrayElement(['MATCH', 'MISMATCH', 'SKIPPED']))) !== null && _q !== void 0 ? _q : null,
        consent_captured_at: (_r = faker_1.faker.helpers.maybe(() => faker_1.faker.date.recent({ days: 30 }).toISOString())) !== null && _r !== void 0 ? _r : null,
        consent_content: (_s = faker_1.faker.helpers.maybe(() => faker_1.faker.lorem.paragraph())) !== null && _s !== void 0 ? _s : null,
        failure_reason: (_t = faker_1.faker.helpers.maybe(() => faker_1.faker.lorem.paragraph())) !== null && _t !== void 0 ? _t : null,
        verified_at: (_u = faker_1.faker.helpers.maybe(() => faker_1.faker.date.recent({ days: 30 }).toISOString())) !== null && _u !== void 0 ? _u : null,
        extras: (_v = faker_1.faker.helpers.maybe(() => Object.fromEntries(faker_1.faker.helpers
            .arrayElements(faker_1.faker.lorem.words().split(' '), { min: 1, max: 5 })
            .map((word) => [word, faker_1.faker.string.alpha()])))) !== null && _v !== void 0 ? _v : null,
        created_at: faker_1.faker.date.recent({ days: 30 }).toISOString(),
        last_updated_at: faker_1.faker.date.recent({ days: 30 }).toISOString(),
    };
}
function fakeWorkerTdsEligibility() {
    return {
        id: faker_1.faker.number.bigInt().toString(),
        worker_id: faker_1.faker.number.bigInt().toString(),
        financial_year: faker_1.faker.lorem.words({ min: 2, max: 10 }).slice(0, 16),
        tds_applicable: faker_1.faker.datatype.boolean(),
        created_at: faker_1.faker.date.recent({ days: 30 }).toISOString(),
        last_updated_at: faker_1.faker.date.recent({ days: 30 }).toISOString(),
    };
}
function fakeWorkerProjectFyEarnings() {
    return {
        id: faker_1.faker.number.bigInt().toString(),
        worker_id: faker_1.faker.number.bigInt().toString(),
        project_id: faker_1.faker.number.bigInt().toString(),
        financial_year: faker_1.faker.lorem.words({ min: 2, max: 10 }).slice(0, 10),
        total_earnings: faker_1.faker.number.bigInt().toString(),
        created_at: faker_1.faker.date.recent({ days: 30 }).toISOString(),
        last_updated_at: faker_1.faker.date.recent({ days: 30 }).toISOString(),
    };
}
function fakeWorkerProjectFyTransfers() {
    return {
        id: faker_1.faker.number.bigInt().toString(),
        worker_id: faker_1.faker.number.bigInt().toString(),
        project_id: faker_1.faker.number.bigInt().toString(),
        financial_year: faker_1.faker.lorem.words({ min: 2, max: 10 }).slice(0, 10),
        total_transferred: faker_1.faker.number.bigInt().toString(),
        total_tds_deducted: faker_1.faker.number.bigInt().toString(),
        created_at: faker_1.faker.date.recent({ days: 30 }).toISOString(),
        last_updated_at: faker_1.faker.date.recent({ days: 30 }).toISOString(),
    };
}
//# sourceMappingURL=FakeDataGenerators.js.map